// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T18:29:37.322Z
// Property: Piper Lofts (ID: 6767906449167479)
// Collections: 25 amenities, 8 floorplans (live), 23 photos, 44 POIs, 5 reviews, 10 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162273",
  "multihub_property_id": "6767906449167479",
  "property_external_id": "1374736",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/piper-lofts-kansas-city-mo/47jcrph/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "piper-lofts",
  "property_name": "Piper Lofts",
  "property_website_url": "https://www.piperlofts.com/",
  "property_domain": null,
  "property_address": "117 W 20th St",
  "property_full_address": "117 W 20th St, Kansas City, MO 64108",
  "property_address_1": "117 W 20th St",
  "property_address_2": null,
  "property_address_city": "Kansas City",
  "property_address_state": "MO",
  "property_address_zip_full": null,
  "property_address_zip": "64108",
  "property_address_country": "US",
  "property_address_county": "Jackson County",
  "property_neighborhood_address": "Crossroads",
  "property_address_latitude": "39.088907",
  "property_address_longitude": "-94.58573779999999",
  "property_email": null,
  "property_phone": "816-323-5787",
  "property_call_tracking_phone": null,
  "property_company_name": "Repli Sandbox",
  "property_company_url": "testurl.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Historic loft character meets Crossroads energy.</strong> Explore open one-, two-, and three-bedroom <a href=\"/floor-plans\">loft layouts</a> with exposed brick, oversized windows, polished concrete, and skyline views—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Piper Lofts in vivid focus.</p>",
  "property_long_description": "<p><strong>Historic loft character, skyline energy, and true Crossroads access.</strong> Piper Lofts brings you into the landmark H.D. Lee Building with the details that make downtown Kansas City living feel unmistakable: exposed brick, polished concrete floors, oversized windows, stainless steel appliances, granite countertops, smart locks, in-home laundry, and open one-, two-, and three-bedroom <a href=\"/floor-plans\">loft layouts</a> with plenty of personality.</p><p>Beyond your front door, <a href=\"/amenities\">rooftop pool days</a>, a 24-hour fitness center, covered garage parking, elevators, Luxer package lockers, a micro market, valet trash, and new pet-focused spaces keep daily routines simple. Step into the Crossroads Arts District for galleries, First Fridays, coffee, restaurants, breweries, and live performance, or hop the nearby KC Streetcar at 19th &amp; Main for a fare-free ride toward Union Station, Power &amp; Light, River Market, the Plaza, and UMKC. From skyline views of Liberty Memorial, Union Station, and Downtown KC to a neighborhood built around art and movement, Piper Lofts puts the city in vivid focus.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-878f-7201-9145-7ddf929ae6a6.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of the Piper Lofts building with a clock tower and cityscape in the background.",
    "public_id": "01a010e6-878f-7201-9145-7ddf929ae6a6",
    "storage_key": "property/6767906449167479/01a010e6-878f-7201-9145-7ddf929ae6a6.webp",
    "width": 820,
    "height": 450
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Maximum of 2 pets allowed in the apartment home.",
  "property_pet_policy_description": "Our community is happy to accept dogs and cats. Maximum of 2 pets allowed in the apartment home. Monthly rent $25.00 per pet. $300 non‑refundable fee for 1 pet; $500 non‑refundable fee for 2 pets.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": null,
  "property_primary_logo_media": null,
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": null,
  "property_mono_white_logo_media": null,
  "property_mono_black_logo": null,
  "property_mono_black_logo_media": null,
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019cfdd9-c8a4-71d3-8bff-111ee22aee5d.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": null,
  "property_secondary_color": null,
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": null,
  "property_bedrooms_min": null,
  "property_bedrooms_max": null,
  "property_bathrooms_range": null,
  "property_bathrooms_min": null,
  "property_bathrooms_max": null,
  "property_sqft_range": null,
  "property_sqft_min": null,
  "property_sqft_max": null,
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": null,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJWfxCC0HwwIcR8bJIuT2Waps",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Piper Lofts",
  "property_home_romance_title": "Embrace Your Dream Life in Our Charming Apartment Community",
  "property_home_amenities_blurb": null,
  "property_home_floorplans_blurb": null,
  "property_home_gallery_blurb": null,
  "property_home_neighborhood_blurb": null,
  "property_home_reviews_blurb": "<p><strong>Residents have plenty to say about Piper Lofts.</strong> Reviews highlight a team that’s responsive, kind, and genuinely helpful, with April, Tiffany, and the Piper team earning frequent shoutouts. Everyday favorites include resident events, pet-friendly touches, spacious lofts, city views, and a Crossroads location that keeps Kansas City close. Read more to see why one resident called Piper Lofts the “Best lofts in KC!!!”</p>",
  "property_neighborhood_blurb": null,
  "property_accessibility_blurb": null,
  "property_amenities_blurb": null,
  "property_applynow_blurb": "<p><strong>Ready for loft living with real Kansas City character?</strong> Piper Lofts pairs landmark exposed brick, oversized windows, polished concrete floors, and open layouts with everyday conveniences that keep life moving. Start your online application today and take the next step toward calling Piper Lofts home.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong><br>Connect with the Piper Lofts leasing team for help exploring historic loft living in the landmark H.D. Lee Building, from open layouts and character-rich finishes to true Crossroads access. We’re here to point you in the right direction.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Piper Lofts?</strong> Start here for quick answers on leasing, loft living, amenities, pet-focused spaces, parking, packages, and everyday details inside the landmark H.D. Lee Building. If you need anything else, the leasing team is happy to help you find the information you need.</p>",
  "property_floorplans_blurb": "<p><strong>Find the loft layout that fits how you live.</strong> Piper Lofts gives you more than a standard one-, two-, or three-bedroom search: explore a collection of open loft plans, from streamlined one-bedrooms to expansive multi-bedroom homes with extra room to spread out, work, host, or unwind. Inside, industrial character meets everyday function with exposed brick, polished concrete flooring, oversized windows, granite countertops, stainless steel appliances, keyless smart locks, and in-home laundry. Select layouts raise the bar with kitchen islands, soaking tubs with Jacuzzi jets, and skyline-view windows that make the floor plan feel even more distinctive. Compare available options, then take a closer look at the <a href=\"/gallery\">apartment photos</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite Crossroads layout in person.</p>",
  "property_gallery_blurb": null,
  "property_interactivemap_blurb": "<p><strong>Map your Crossroads connection.</strong> Explore available loft layouts at Piper Lofts, then use the interactive map to see how galleries, First Fridays, coffee, restaurants, breweries, live performance, and the nearby KC Streetcar put downtown Kansas City in motion around you.</p>",
  "property_pets_blurb": null,
  "property_referafriend_blurb": "<p><strong>Share the loft life you love.</strong> Invite a friend to experience Piper Lofts’ historic brick character, skyline energy, open loft layouts, and true Crossroads access. Send a referral today and help them picture downtown KC living with personality.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Piper Lofts.</strong><br>Keep downtown routines simple from your account portal—pay rent, submit maintenance requests, and manage your home details with ease. From the historic H.D. Lee Building’s loft character to everyday conveniences like smart locks, in-home laundry, and Luxer package lockers, Piper Lofts keeps connected living close at hand.</p>",
  "property_reviews_blurb": "<p><strong>Real resident feedback, straight from Piper Lofts.</strong> As you read the reviews, you’ll notice a clear theme: residents feel heard, welcomed, and well taken care of. April, Tiffany, and the Piper team are called out again and again for being responsive, kind, and genuinely helpful—one resident summed it up simply: “they really care.”</p><p>You’ll also see praise for the everyday details that make life here feel connected, from resident events and pet-friendly touches to spacious lofts, city views, and a Crossroads location residents love. Browse the stories below and see why one review calls Piper Lofts the “Best lofts in KC!!!”</p>",
  "property_created_at": "1786989888629",
  "property_scheduletour_blurb": "<p><strong>See Piper Lofts in person.</strong> Tour historic loft character inside the landmark H.D. Lee Building, from exposed brick and polished concrete floors to oversized windows, skyline energy, and open loft layouts. Book your visit and picture downtown Kansas City living up close.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong> The Piper Lofts leasing team will be in touch soon. In the meantime, picture historic loft character in the landmark H.D. Lee Building, with exposed brick, oversized windows, and open <a href=\"/floor-plans\">loft layouts</a> in the heart of the Crossroads.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. Piper Lofts",
  "property_seo_title_home": "Piper Lofts |  Apartments in Kansas City, MO",
  "property_seo_description_home": "Experience luxury living at Piper Lofts in Kansas City! Choose from stylish one to three-bedroom apartments with unbeatable amenities and skyline views.",
  "property_seo_title_floorplans": "Floor Plans | Kansas City, MO Apartments for Rent",
  "property_seo_description_floorplans": "Elevate your lifestyle at Piper Lofts in Kansas City, MO. Browse unique one, two, and three-bedroom floor plans to find your perfect fit today!",
  "property_seo_title_amenities": "Amenities | Kansas City, MO Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at Piper Lofts! Enjoy spacious layouts, a rooftop pool, modern amenities, and scenic skyline views in the heart of Kansas City.",
  "property_seo_title_gallery": "Gallery | Apartments in Kansas City, MO",
  "property_seo_description_gallery": "Live the high life at Piper Lofts in Kansas City! With stunning skyline views and unique layouts, your dream apartment awaits. Picture your future today!",
  "property_seo_title_virtualtours": "Virtual Tours | Piper Lofts Apartments",
  "property_seo_description_virtualtours": "Step into your future home at Piper Lofts in Kansas City! Experience our stylish one, two, and three-bedroom apartments with a virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | Piper Lofts Apartments",
  "property_seo_description_interactivemap": "Discover Kansas City living at Piper Lofts! Explore our interactive map to find your dream apartment with skyline views and modern amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Kansas City, MO",
  "property_seo_description_neighborhood": "Discover the lively Kansas City scene near Piper Lofts! Enjoy local favorites, parks, and attractions just steps from our stylish apartments.",
  "property_seo_title_contact": "Contact Us | Piper Lofts",
  "property_seo_description_contact": "Connect with Piper Lofts in Kansas City! Our leasing team is ready to help you choose from our stylish one, two, and three-bedroom floor plans.",
  "property_seo_title_faqs": "FAQs | Apartments in Kansas City, MO",
  "property_seo_description_faqs": "Explore Piper Lofts in Kansas City for unique layouts and top-notch amenities that elevate your living experience!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Kansas City, MO",
  "property_seo_description_reviews": "Join the Piper Lofts community in Kansas City, MO! Residents love our rooftop pool, pet amenities, and stunning skyline views. Hear their stories today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Kansas City, MO",
  "property_seo_description_applynow": "Elevate your lifestyle at Piper Lofts in Kansas City! With stylish apartments, a rooftop pool, & luxury amenities, your dream home awaits. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Piper Lofts",
  "property_seo_description_residentaccess": "Log in to Piper Lofts' Resident Portal for easy rent payment, hassle-free maintenance requests, and community updates—all from the comfort of your home!",
  "property_seo_title_referafriend": "Refer A Friend | Piper Lofts",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Piper Lofts in Kansas City, MO, and enjoy exclusive rewards. Share the love of community living!",
  "property_seo_title_scheduletour": "Schedule a Tour | Piper Lofts",
  "property_seo_description_scheduletour": "Experience the charm of Piper Lofts in Kansas City, MO. Schedule a tour today and envision your stylish new home in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Piper Lofts",
  "property_seo_description_privacy": "At Piper Lofts in Kansas City, your privacy matters. Learn how we protect your personal information in our transparent privacy policy. Read more!",
  "property_seo_title_accessibility": "Website Accessibility | Piper Lofts",
  "property_seo_description_accessibility": "At Piper Lofts in Kansas City, MO, we champion digital inclusion. Experience accessible living designed for everyone, because everyone deserves a home.",
  "property_seo_title_sitemap": "Sitemap | Piper Lofts",
  "property_seo_description_sitemap": "Navigate through Piper Lofts in Kansas City, MO! Uncover amenities, floor plans, and community highlights with our detailed sitemap. Your perfect home awaits!",
  "property_seo_title_thankyou": "Thank You | Piper Lofts",
  "property_seo_description_thankyou": "Thank you for reaching out to Piper Lofts! Our team will be in touch soon to help you find your perfect home in vibrant Kansas City, MO.",
  "property_seo_title_pets": "Pet Policy | Apartments in Kansas City, MO",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1786989888627",
  "amenities": [
    {
      "id": "ec_c400e6c7e37bb9702e57f872",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "NEW Dog Park",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Community” on the official Piper Lofts amenities page.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c2787c2e7697893523131798",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "NEW Pet Spa",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Community.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0efd11f22f8cb76205f26016",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "Covered Parking Garage",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Community.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7b6a7b8feec7fcb9cf77f323",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "Elevators",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Community.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dcfec7259475e22c0d8d489f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "24‑Hour Fitness Center",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Community.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3895a1dadaaad2839825862b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "Rooftop Pool with Sundeck",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Community.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ebeadd87cd1c6430838b95e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "24‑Hour Micro Market",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Community.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bbaa4dda7cd1e00f795a5ef1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "Controlled Access Building",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Community.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9dc126af4b81e3ceb8827941",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "Valet Trash Service",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Community.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e83ed6160e37a23064ab1036",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "Luxer Package Lockers",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Community.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_70afdb95c244795a06fb8980",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "Nearby KC Street Car",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Community.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d729e00440227da0b9aa6891",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "Outdoor Grill",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Community.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_81c08a9eb138bf68dffe09c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "Large Soaking Tub with Jacuzzi Jets *",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Apartment,” including the asterisk and identical wording (*Only Available in Select Units).",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_63c0440d83446dcdf39d02b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Apartment.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3345fdc9f9b13adb93dda2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "Keyless Smart Locks",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Apartment.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb722b6dd3ca94ade0e53fc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "Washer and Dryer Included",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Apartment.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ca2af29367943459f58f64d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Apartment.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_022073ba5bc2218b1672874d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "Loft‑Style Open Layouts",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Apartment.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_041d54bcbe71fce617bc9268",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "Exposed Brick",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Apartment.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_88398f0dd05ad5bee9f2e7b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "Skyline Views of Liberty Memorial, Union Station, and Downtown",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Apartment.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_11541913541a9608bda8fe56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "Kitchen Islands *",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Apartment,” including the asterisk and identical wording (*Only Available in Select Units).",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a04472f4b76711d0c47b1015",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Apartment.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ca0119b71c0616601dccec5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "Oversized Windows",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Apartment.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_61c8dcd8266b10d561f1ec50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "Polished Concrete Flooring",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Apartment.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_07a542897f89a0e25ae0f29a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "external_id": "false",
      "title": "Over 20 Unique Layouts",
      "amount": "false",
      "description": "Exists exactly as listed under “Your Apartment.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_e4cb172299689f9b99d5a884",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-4004-76dc-846d-c2a32976a2cc.webp",
      "image_media": {
        "alt_text": "Couple with a dog on a bed",
        "public_id": "01a010e6-4004-76dc-846d-c2a32976a2cc",
        "storage_key": "property/6767906449167479/01a010e6-4004-76dc-846d-c2a32976a2cc.webp",
        "width": 500,
        "height": 500
      },
      "title": "Lifestyle",
      "description": "We are a pet-friendly community",
      "link": "false",
      "alt_text": "a couple playing with their pet",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://piperlofts.com/assets/images/cache/pets-17e17d4c7238d020759ffcefdab6c669.jpg"
    },
    {
      "id": "ec_dda7feeb61a2b6733339a823",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-4032-721b-b6aa-b409909b0b20.webp",
      "image_media": {
        "alt_text": "Piper Lofts building exterior with prominent signage.",
        "public_id": "01a010e6-4032-721b-b6aa-b409909b0b20",
        "storage_key": "property/6767906449167479/01a010e6-4032-721b-b6aa-b409909b0b20.webp",
        "width": 1800,
        "height": 700
      },
      "title": "Community",
      "description": "Gallery",
      "link": "false",
      "alt_text": "Gallery",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://piperlofts.com/assets/images/cache/13-117-W-20th-St-101-c5c3320e4732b3438b6e40b899c4e0ca.jpg"
    },
    {
      "id": "ec_bde6e5a580e6755d813918b1",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-3c33-707e-8d75-035b4db84224.webp",
      "image_media": {
        "alt_text": "Stacked white washer and dryer unit in a small laundry closet with a door and a sink visible.",
        "public_id": "01a010e6-3c33-707e-8d75-035b4db84224",
        "storage_key": "property/6767906449167479/01a010e6-3c33-707e-8d75-035b4db84224.webp",
        "width": 820,
        "height": 450
      },
      "title": "Apartment",
      "description": "Washer and Dryer in Apartment Home",
      "link": "false",
      "alt_text": "Stacked washer and dryer unit inside Piper Lofts apartment with nearby vanity and storage space",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://piperlofts.com/assets/images/cache/Piper-Lofts-025_Photo_Interior_Washer-and-Dryer-2_2026-05-28-3e6a74b715b5696f8b00ae565968a065.jpg"
    },
    {
      "id": "ec_5067e795815914f7366ed4b7",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-402a-734c-9767-d48456284f07.webp",
      "image_media": {
        "alt_text": "Walk-in closet with organized clothes and shoes, bench, plant, and artwork.",
        "public_id": "01a010e6-402a-734c-9767-d48456284f07",
        "storage_key": "property/6767906449167479/01a010e6-402a-734c-9767-d48456284f07.webp",
        "width": 820,
        "height": 450
      },
      "title": "Apartment",
      "description": "Spacious Walk-In Closet",
      "link": "false",
      "alt_text": "Walk-in closet at Piper Lofts with hanging storage, shelving, and neatly arranged clothing",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://piperlofts.com/assets/images/cache/Piper-Lofts-025_Photo_Staged-Interior_Closet_2026-05-28-943125693552f3a2a845dc820c436e61.jpg"
    },
    {
      "id": "ec_3bdf2584ad72a83834056c1d",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-3c39-739b-8721-f88ccee459f5.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a single vanity, mirror, and shelving unit with towels.",
        "public_id": "01a010e6-3c39-739b-8721-f88ccee459f5",
        "storage_key": "property/6767906449167479/01a010e6-3c39-739b-8721-f88ccee459f5.webp",
        "width": 820,
        "height": 450
      },
      "title": "Apartment",
      "description": "Modern Bathroom with Storage Shelving",
      "link": "false",
      "alt_text": "Bathroom interior with vanity, large mirror, and open shelving with towels and decor accents",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://piperlofts.com/assets/images/cache/Piper-Lofts-025_Photo_Staged-Interior_Bathroom_Shelves_2026-05-28-a9d5665fa83219d1cff6ce3c6e6e291d.jpg"
    },
    {
      "id": "ec_74f83eb621a9c983c11cfc72",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-3e82-7415-84ea-7ccbde413e15.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, dark cabinets, and granite countertops.",
        "public_id": "01a010e6-3e82-7415-84ea-7ccbde413e15",
        "storage_key": "property/6767906449167479/01a010e6-3e82-7415-84ea-7ccbde413e15.webp",
        "width": 820,
        "height": 450
      },
      "title": "Apartment",
      "description": "Modern Kitchen with Stainless Steel Appliances",
      "link": "false",
      "alt_text": "Apartment kitchen at Piper Lofts with stainless steel oven, microwave, dark cabinetry, and black countertops",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://piperlofts.com/assets/images/cache/Piper-Lofts-025_Photo_Staged-Interior_Kitchen-2_2026-05-28-71afd00c3c605d52005f34d58734f6b6.jpg"
    },
    {
      "id": "ec_f7448cb5e4835f78c31e1724",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-4014-76af-99c8-286e479a913f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, dark cabinets, and a concrete floor.",
        "public_id": "01a010e6-4014-76af-99c8-286e479a913f",
        "storage_key": "property/6767906449167479/01a010e6-4014-76af-99c8-286e479a913f.webp",
        "width": 820,
        "height": 450
      },
      "title": "Apartment",
      "description": "Spacious Kitchen with Open Layout",
      "link": "false",
      "alt_text": "Kitchen at Piper Lofts featuring stainless steel fridge, farmhouse sink, and modern cabinetry",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://piperlofts.com/assets/images/cache/Piper-Lofts-025_Photo_Staged-Interior_Kitchen-3_2026-05-28-060d0438163d687f955ad38768a74c84.jpg"
    },
    {
      "id": "ec_c0441eb6dd0958d484689348",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-3e81-72fc-ad05-d65dd4d1a77c.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment with exposed brick walls and industrial accents.",
        "public_id": "01a010e6-3e81-72fc-ad05-d65dd4d1a77c",
        "storage_key": "property/6767906449167479/01a010e6-3e81-72fc-ad05-d65dd4d1a77c.webp",
        "width": 820,
        "height": 450
      },
      "title": "Apartment",
      "description": "Open-Concept Loft Living Space",
      "link": "false",
      "alt_text": "Open living room and kitchen area with large windows, exposed concrete ceiling, and natural light",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://piperlofts.com/assets/images/cache/Piper-Lofts-025_Photo_Staged-Interior_LivingRoom_2026-05-28-14e43473a40f668c063b65c26c4d09f6.jpg"
    },
    {
      "id": "ec_ea3db88932b2aae311ca596c",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-431c-7210-94b8-b42f31bf4250.webp",
      "image_media": {
        "alt_text": "Stainless steel refrigerator and modern kitchen with granite countertops and wooden cabinets.",
        "public_id": "01a010e6-431c-7210-94b8-b42f31bf4250",
        "storage_key": "property/6767906449167479/01a010e6-431c-7210-94b8-b42f31bf4250.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Where comfort and convenience meet",
      "link": "false",
      "alt_text": "a kitchen with a stainless steel refrigerator",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://piperlofts.com/assets/images/cache/yubwpsn0CsO6Nzez7vaj6rHhQoQbDNTiREwZnWts-0aa5e3f4d5c3e28bcb268d9f714a49bf.jpg"
    },
    {
      "id": "ec_65cf004c064ad65dcec687c8",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-443a-737e-8be9-c419dbb23e8a.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, two nightstands, and a bench at the foot of the bed.",
        "public_id": "01a010e6-443a-737e-8be9-c419dbb23e8a",
        "storage_key": "property/6767906449167479/01a010e6-443a-737e-8be9-c419dbb23e8a.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Bedroom options to fit every lifestyle",
      "link": "false",
      "alt_text": "a bedroom with a bed and a door",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://piperlofts.com/assets/images/cache/Q1LELZoymZugsNmxLnyY3KjRbqopr5UMlNBiXkGh-2f3d5dfe57c94a0a857bef63fc5d5b56.jpg"
    },
    {
      "id": "ec_cc2c76ffb66301d846f9ad4e",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-57fc-77ef-b2c2-7dc1de930cd3.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a stacked washer/dryer, a glass-top vanity, and a gray tiled shower/tub.",
        "public_id": "01a010e6-57fc-77ef-b2c2-7dc1de930cd3",
        "storage_key": "property/6767906449167479/01a010e6-57fc-77ef-b2c2-7dc1de930cd3.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Piper Lofts Jacuzzi Tub in Kansas City",
      "link": "false",
      "alt_text": "Luxurious soaking tub with jacuzzi jets inside a loft at Piper Lofts in Kansas City",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://piperlofts.com/assets/images/cache/1uEKyRkfIY3QLi9ODAdlKZ4ntQEwpSrSddukzm8z-5b7b3d4e63187f3665e4c04eac332f1d.jpg"
    },
    {
      "id": "ec_52185e7c0969002184419c3e",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-5bae-75ae-a347-d8217af2dc00.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a king-size bed, city view, and industrial accents.",
        "public_id": "01a010e6-5bae-75ae-a347-d8217af2dc00",
        "storage_key": "property/6767906449167479/01a010e6-5bae-75ae-a347-d8217af2dc00.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Relax and recharge in beautiful and spacious bedrooms",
      "link": "false",
      "alt_text": "a bedroom with a large window",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://piperlofts.com/assets/images/cache/ZIrZGofQvwIUzPhu5IYJYiUZWys53hnto5Uj975y-f38e5ed8185119a6526055b4d1b90f61.jpg"
    },
    {
      "id": "ec_3f24728ce712dcd1ea2d4156",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-5d85-76b9-9a57-a6c120374e36.webp",
      "image_media": {
        "alt_text": "Open concept living area and kitchen with large windows and exposed brick.",
        "public_id": "01a010e6-5d85-76b9-9a57-a6c120374e36",
        "storage_key": "property/6767906449167479/01a010e6-5d85-76b9-9a57-a6c120374e36.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Find your perfect fit at Piper Lofts",
      "link": "false",
      "alt_text": "a large empty kitchen",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://piperlofts.com/assets/images/cache/EcCPqDj5dV0Z7oOQLqe4aXvqoNMYutwEQ49m1a3p-1166b96d31085d996ba8a95104fbe81f.jpg"
    },
    {
      "id": "ec_6a9849b41aa3a0f04151c312",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-5c73-7338-a958-006a1a45e660.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and a large island.",
        "public_id": "01a010e6-5c73-7338-a958-006a1a45e660",
        "storage_key": "property/6767906449167479/01a010e6-5c73-7338-a958-006a1a45e660.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious kitchens with thoughtful details",
      "link": "false",
      "alt_text": "a kitchen with stainless steel appliances",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://piperlofts.com/assets/images/cache/diTkRzR98LWY66wBUvrX73ejOG56KTWUpmDbR7N3-11717055b0be4468e5870570220885f2.jpg"
    },
    {
      "id": "ec_37081e560f4d7d03902d21f0",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-5bae-75ae-a347-df40c478da3e.webp",
      "image_media": {
        "alt_text": "Modern living and dining area with open kitchen in apartment with exposed brick.",
        "public_id": "01a010e6-5bae-75ae-a347-df40c478da3e",
        "storage_key": "property/6767906449167479/01a010e6-5bae-75ae-a347-df40c478da3e.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Everything you need right at your fingertips",
      "link": "false",
      "alt_text": "a living room with a large brick wall and a large window",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://piperlofts.com/assets/images/cache/EbBbHMd9KRPzsSCMfDJ5ZvJjK10PzPYVZN6lLIaF-50df2e39f24c7718ad5d8240d8c79b9f.jpg"
    },
    {
      "id": "ec_fac0dea3cd63919970171139",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-5ab3-777a-8325-449b7885e5ac.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a walk-in shower, modern sink, and toilet.",
        "public_id": "01a010e6-5ab3-777a-8325-449b7885e5ac",
        "storage_key": "property/6767906449167479/01a010e6-5ab3-777a-8325-449b7885e5ac.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious bathrooms with everything you need",
      "link": "false",
      "alt_text": "a bathroom with a glass shower",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://piperlofts.com/assets/images/cache/9QALfjTcovr7IP9EDZulR0xC5NJZPwReE6huDTic-f2bfd89ab626974a7406655c48fcac00.jpg"
    },
    {
      "id": "ec_413b1e655e071bf28a038f9e",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-5e95-73ed-b61e-6cfcecae3fed.webp",
      "image_media": {
        "alt_text": "Living room with a TV, coffee table, and sofa, featuring large windows with city views.",
        "public_id": "01a010e6-5e95-73ed-b61e-6cfcecae3fed",
        "storage_key": "property/6767906449167479/01a010e6-5e95-73ed-b61e-6cfcecae3fed.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious living areas to recline and recharge",
      "link": "false",
      "alt_text": "a living room with a large window",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://piperlofts.com/assets/images/cache/N29VVMOdAkUAXuJntnQYVxAQ0N2LTO6W0cRI3v1w-9f6d2aab56fc560008289981cc161e8c.jpg"
    },
    {
      "id": "ec_34450950d3b2e954eb29f46b",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-5d7b-76a8-a6c3-0ff98ba8b2f9.webp",
      "image_media": {
        "alt_text": "Modern dining area with table and chairs, adjacent to a kitchen with stainless steel appliances.",
        "public_id": "01a010e6-5d7b-76a8-a6c3-0ff98ba8b2f9",
        "storage_key": "property/6767906449167479/01a010e6-5d7b-76a8-a6c3-0ff98ba8b2f9.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "The essence of exceptional living",
      "link": "false",
      "alt_text": "a kitchen with a dining table",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://piperlofts.com/assets/images/cache/XYmGFS2qP48V7k6Y8yX4c5n0H54sU3MYUxXf6xDI-f3dbbf2f5e1132b383c25bc0d33f3059.jpg"
    },
    {
      "id": "ec_4fefb7b0cc5f4d3db8ce327e",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-5dbd-7092-b639-e474b1b64541.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with modern finishes and concrete ceiling.",
        "public_id": "01a010e6-5dbd-7092-b639-e474b1b64541",
        "storage_key": "property/6767906449167479/01a010e6-5dbd-7092-b639-e474b1b64541.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "A perfect fit for the whole family",
      "link": "false",
      "alt_text": "a living room with a fireplace",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://piperlofts.com/assets/images/cache/GJ37IwEYMtYQs1ny5coN4sE1yq9UypkRPZU7MSWG-3a539725e422dca13cc1a59739e575af.jpg"
    },
    {
      "id": "ec_c3edc9d7c1a64d7d3901cc01",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-5fab-759f-bb27-b712405347ec.webp",
      "image_media": {
        "alt_text": "A streetcar in Kansas City, Missouri, is at a stop with people boarding.",
        "public_id": "01a010e6-5fab-759f-bb27-b712405347ec",
        "storage_key": "property/6767906449167479/01a010e6-5fab-759f-bb27-b712405347ec.webp",
        "width": 820,
        "height": 450
      },
      "title": "Community",
      "description": "A streetcar in Kansas City, Missouri, with the destination 'Riverfront' displayed, is stopped at a station where passengers are boarding. The surrounding urban environment includes buildings and traffic.",
      "link": "false",
      "alt_text": "A streetcar in Kansas City, Missouri, is at a stop with people boarding.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://piperlofts.com/assets/images/cache/Piper-Lofts-025_Photo_Nearest-Streetcar-Stop-1_With-People_2026-05-28-06032803e76191dd142cf43fb8fd6a10.jpg"
    },
    {
      "id": "ec_a016cc8471a29393d5a42da9",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-8744-74e9-ab67-498e27e44fa2.webp",
      "image_media": {
        "alt_text": "Streetcar stop with signage and people walking by.",
        "public_id": "01a010e6-8744-74e9-ab67-498e27e44fa2",
        "storage_key": "property/6767906449167479/01a010e6-8744-74e9-ab67-498e27e44fa2.webp",
        "width": 820,
        "height": 450
      },
      "title": "Community",
      "description": "Enjoy convenient transportation options with a nearby streetcar stop, making it easy to explore the city.",
      "link": "false",
      "alt_text": "Streetcar stop with signage and people walking by.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://piperlofts.com/assets/images/cache/Piper-Lofts-025_Photo_Nearest-Streetcar-Stop-3_With-People_2026-05-28-5d54840d1b972fca4d3156cfe20c0157.jpg"
    },
    {
      "id": "ec_0dd6a6f66a411cd65c4c185b",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-878f-7201-9145-7ddf929ae6a6.webp",
      "image_media": {
        "alt_text": "Exterior view of the Piper Lofts building with a clock tower and cityscape in the background.",
        "public_id": "01a010e6-878f-7201-9145-7ddf929ae6a6",
        "storage_key": "property/6767906449167479/01a010e6-878f-7201-9145-7ddf929ae6a6.webp",
        "width": 820,
        "height": 450
      },
      "title": "Community",
      "description": "Experience city living at Piper Lofts, featuring a unique clock tower and stunning urban views. Located in the heart of the city.",
      "link": "false",
      "alt_text": "Exterior view of the Piper Lofts building with a clock tower and cityscape in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://piperlofts.com/assets/images/cache/Piper-Lofts-025_Photo_Building-Exterior_Tower-Sign-2_2026-05-28-c07fff303defd6fd8a1979c42c641622.jpg"
    },
    {
      "id": "ec_9b244e244fa91ba16ca4672f",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-8936-72cd-8819-4dbd45bfc879.webp",
      "image_media": {
        "alt_text": "Electric car charging station in a parking garage.",
        "public_id": "01a010e6-8936-72cd-8819-4dbd45bfc879",
        "storage_key": "property/6767906449167479/01a010e6-8936-72cd-8819-4dbd45bfc879.webp",
        "width": 820,
        "height": 450
      },
      "title": "Community",
      "description": "Convenient electric vehicle charging stations are available in our resident parking garage.",
      "link": "false",
      "alt_text": "Electric car charging station in a parking garage.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://piperlofts.com/assets/images/cache/Piper-Lofts-025_Photo_EV-Charging-Station-1_2026-05-28-03acce2ac7e3ddbdf1a97024665cad47.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_8ea776aafef0551b5fe63799",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Joe's KC BBQ",
      "poi_type": "Restaurants",
      "poi_address": "3002 W 47th Ave, Kansas City, KS 66103, USA",
      "poi_short_description": "Relaxed BBQ pit stop for slabs of ribs, pulled pork sandwiches, meat by the pound & sides.",
      "poi_long_description": "People say this barbecue restaurant offers delicious ribs, brisket, and the popular Z-Man sandwich, with many highlighting the flavorful sides like mac and cheese and seasoned fries. They also mention the friendly and efficient staff, who manage long lines quickly. Visitors appreciate the lively atmosphere and the unique experience of dining in a converted gas station.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e5-e71e-713b-81f7-ed6b815cf961.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e5-e71e-713b-81f7-ed6b815cf961",
        "storage_key": "property/6767906449167479/01a010e5-e71e-713b-81f7-ed6b815cf961.webp",
        "width": 1280,
        "height": 445
      },
      "poi_business_url": "https://www.joeskc.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=1535412546490701816&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "joes-kc-bbq",
      "poi_latitude": "39.0444482",
      "poi_longitude": "-94.6207405",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-722-3366",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-ba9c-768a-b934-ed3461c15c81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-ba9c-768a-b934-ed3461c15c81",
        "storage_key": "property/6767906449167479/01a010e6-ba9c-768a-b934-ed3461c15c81.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJeelZFz_uwIcR-JdBeZPhThU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_5bf32834446996bf76fc408f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Jack Stack Barbecue - Freight House",
      "poi_type": "Restaurants",
      "poi_address": "101 W 22nd St, Kansas City, MO 64108, USA",
      "poi_short_description": "Bustling local chain known for its vast barbecue menu encompassing steak & seafood.",
      "poi_long_description": "People say this barbecue restaurant offers delicious, tender meats like lamb ribs and burnt ends, along with standout sides such as baked beans and cheesy corn. They also highlight the excellent, attentive service and the warm, inviting atmosphere, often recommending reservations due to its popularity.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e5-f99e-73bd-939f-a2e953f66758.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e5-f99e-73bd-939f-a2e953f66758",
        "storage_key": "property/6767906449167479/01a010e5-f99e-73bd-939f-a2e953f66758.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.jackstackbbq.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=14717886139068817346&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jack-stack-barbecue---freight-house",
      "poi_latitude": "39.0875678",
      "poi_longitude": "-94.5850052",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-472-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-ba9c-768a-b934-ed3461c15c81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-ba9c-768a-b934-ed3461c15c81",
        "storage_key": "property/6767906449167479/01a010e6-ba9c-768a-b934-ed3461c15c81.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmzokTUDwwIcRwp_X-3ZvQMw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_646247b554c1b6d1667e5d9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Q39 - Midtown",
      "poi_type": "Restaurants",
      "poi_address": "1000 W 39th St, Kansas City, MO 64111, USA",
      "poi_short_description": "Hip, airy joint with beamed ceilings & exposed brick serving smoked BBQ & wood-fired meats.",
      "poi_long_description": "People say this restaurant offers delicious burnt ends, tender brisket, and flavorful ribs, with many highlighting the award-winning wings and tasty sides like Mexican street corn and mac and cheese. They also mention the fast service, reasonable prices, and welcoming atmosphere. Guests appreciate the knowledgeable and attentive staff, who provide excellent recommendations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e5-e730-70d0-864b-fcaae7f09ba0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e5-e730-70d0-864b-fcaae7f09ba0",
        "storage_key": "property/6767906449167479/01a010e5-e730-70d0-864b-fcaae7f09ba0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://q39kc.com/locations/kansas-city-bbq/?utm_source=Google&utm_medium=Maps&utm_campaign=GBP_midtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=5504754235694060525&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "q39---midtown",
      "poi_latitude": "39.0573424",
      "poi_longitude": "-94.5982173",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-255-3753",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-ba9c-768a-b934-ed3461c15c81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-ba9c-768a-b934-ed3461c15c81",
        "storage_key": "property/6767906449167479/01a010e6-ba9c-768a-b934-ed3461c15c81.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ541xZ9HvwIcR7RNf2s_QZEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_7c08d66d2ca145a1a2b36852",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Slap's BBQ",
      "poi_type": "Restaurants",
      "poi_address": "553 Central Ave, Kansas City, KS 66101, USA",
      "poi_short_description": "No-nonsense barbecue joint serving classics such as brisket & hushpuppies from a counter.",
      "poi_long_description": "People say this barbecue joint offers exceptional ribs, tender burnt ends, and flavorful pulled pork, with the potato casserole and cheesy corn highlighted as standout sides. They also mention the generous portions and reasonable prices, making it a great value. Visitors appreciate the casual, authentic barbecue atmosphere with picnic table seating and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e5-e7e7-763f-be2b-516cab49731d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e5-e7e7-763f-be2b-516cab49731d",
        "storage_key": "property/6767906449167479/01a010e5-e7e7-763f-be2b-516cab49731d.webp",
        "width": 1280,
        "height": 764
      },
      "poi_business_url": "http://www.slapsbbqkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1468038267828269090&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "slaps-bbq",
      "poi_latitude": "39.1024332",
      "poi_longitude": "-94.6244166",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-213-3736",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-ba9c-768a-b934-ed3461c15c81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-ba9c-768a-b934-ed3461c15c81",
        "storage_key": "property/6767906449167479/01a010e6-ba9c-768a-b934-ed3461c15c81.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL3nsh5_xwIcRInCVzgaFXxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_888d8d6a2c2b1840355bc072",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "4040 Mill St, Kansas City, MO 64111, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this restaurant offers delicious, hot, and fresh chicken fingers with a crunchy coating, along with tasty Texas toast and their signature sauce. They also highlight the friendly and efficient staff, and appreciate the clean and well-maintained dining area.\n\nSome reviews mention the service can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e5-e835-75aa-b54d-c46a30b0f3fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e5-e835-75aa-b54d-c46a30b0f3fb",
        "storage_key": "property/6767906449167479/01a010e5-e835-75aa-b54d-c46a30b0f3fb.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/mo/kansas-city/4040-mill-street",
      "poi_directions_map_url": "https://maps.google.com/?cid=1276521902534524461&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "39.053215",
      "poi_longitude": "-94.5938892",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 816-561-1316",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-ba9c-768a-b934-ed3461c15c81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-ba9c-768a-b934-ed3461c15c81",
        "storage_key": "property/6767906449167479/01a010e6-ba9c-768a-b934-ed3461c15c81.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4awZ-8_vwIcRLX6TNOgdtxE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_7171ed3f35fec4e08a15bdf8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "301 E 51st St, Kansas City, MO 64112, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Visitors say this grocery store offers a wide selection of organic produce, fresh fish, and specialty items, including a popular hot food bar and salad bar. They also highlight the friendly and helpful staff, the clean and well-organized store, and the convenient Amazon return service.\n\nSome reviews mention the staff can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e5-ebf3-73d9-b660-26712c4c0dbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e5-ebf3-73d9-b660-26712c4c0dbf",
        "storage_key": "property/6767906449167479/01a010e5-ebf3-73d9-b660-26712c4c0dbf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/kansascity?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=1363009852041094042&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "39.0345383",
      "poi_longitude": "-94.5835874",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 816-708-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-ba98-735a-9562-2914bfe28a97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-ba98-735a-9562-2914bfe28a97",
        "storage_key": "property/6767906449167479/01a010e6-ba98-735a-9562-2914bfe28a97.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ00-juzLvwIcRmmNEKD1i6hI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_afe5da9a2510d9533e54df64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Country Club Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "4706 Broadway Blvd, Kansas City, MO 64112, USA",
      "poi_short_description": "Sprawling shopping area made up of Moorish-themed buildings housing stores & restaurants.",
      "poi_long_description": "Visitors say this shopping district offers a great variety of shops and restaurants, with many highlighting the beautiful Spanish-inspired architecture and numerous fountains. They also appreciate the fun, lively atmosphere, especially during the holiday season when the lights are spectacular. Guests mention the convenient and ample parking options, making it easy to explore the area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e5-e838-70fe-8c6c-d5b3ee120a3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e5-e838-70fe-8c6c-d5b3ee120a3b",
        "storage_key": "property/6767906449167479/01a010e5-e838-70fe-8c6c-d5b3ee120a3b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://countryclubplaza.com/?utm_source=GoogleMyBusiness&utm_medium=Organic&utm_campaign=GMB",
      "poi_directions_map_url": "https://maps.google.com/?cid=12339093817016807577&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "country-club-plaza",
      "poi_latitude": "39.0419692",
      "poi_longitude": "-94.5926089",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-753-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bab2-705c-8379-e5c08efafa15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bab2-705c-8379-e5c08efafa15",
        "storage_key": "property/6767906449167479/01a010e6-bab2-705c-8379-e5c08efafa15.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJr4r_377vwIcRmXCBhXNEPas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_c2544fde5b5bd5d4b257cf1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "111 Linwood Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Customers consistently praise this store for its great selection of lumber and wide variety of quality products suitable for any project, noting that items are easy to locate and accurately labeled. Reviewers also appreciate the friendly staff and the convenience of the self-checkout kiosks.\n\nSome reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e5-e730-70d0-864c-00d601db0ffd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e5-e730-70d0-864c-00d601db0ffd",
        "storage_key": "property/6767906449167479/01a010e5-e730-70d0-864c-00d601db0ffd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.homedepot.com/l/Midtown-Kansas-City/MO/Kansas-City/64111/3021?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=18321544500347867328&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "39.0667183",
      "poi_longitude": "-94.5834267",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-931-7434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bab2-705c-8379-e5c08efafa15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bab2-705c-8379-e5c08efafa15",
        "storage_key": "property/6767906449167479/01a010e6-bab2-705c-8379-e5c08efafa15.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJUUg7LSDwwIcRwBC_v6YzQ_4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_5a97ba3cbdb0bd7029ee04b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "4701 Mission Rd, Westwood, KS 66205, USA",
      "poi_short_description": "false",
      "poi_long_description": "Customers consistently praise this store for being clean and well-stocked with a wide variety of products, including fresh vegetables and a great pharmacy. They also appreciate the competitive prices, convenient parking, and polite staff.\n\nSome reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e5-e838-70fe-8c6c-da6889a6b764.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e5-e838-70fe-8c6c-da6889a6b764",
        "storage_key": "property/6767906449167479/01a010e5-e838-70fe-8c6c-da6889a6b764.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walmart.com/store/998-westwood-ks/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3053635608746536629&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "39.0434603",
      "poi_longitude": "-94.619409",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-563-1751",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-ba98-735a-9562-2914bfe28a97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-ba98-735a-9562-2914bfe28a97",
        "storage_key": "property/6767906449167479/01a010e6-ba98-735a-9562-2914bfe28a97.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Q0DSj_uwIcRtS7SRGixYCo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_6bfbaabee7f73e9f3aba3191",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Cosentino's Sun Fresh Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "4001 Mill St, Kansas City, MO 64111, USA",
      "poi_short_description": "Supermarket offering produce, prepared foods, and organic products, plus a pharmacy, a florist, and a liquor store.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e5-ea52-752b-838d-2076a6a2c28b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e5-ea52-752b-838d-2076a6a2c28b",
        "storage_key": "property/6767906449167479/01a010e5-ea52-752b-838d-2076a6a2c28b.webp",
        "width": 1280,
        "height": 679
      },
      "poi_business_url": "https://cosentinos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9583179988153697737&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cosentinos-sun-fresh-market",
      "poi_latitude": "39.054676",
      "poi_longitude": "-94.594949",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-931-1639",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-ba98-735a-9562-2914bfe28a97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-ba98-735a-9562-2914bfe28a97",
        "storage_key": "property/6767906449167479/01a010e6-ba98-735a-9562-2914bfe28a97.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcHUGdDvwIcRyYWI5GxL_oQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_34c3aa690bb3e9eb0b2a3938",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "University of Missouri-Kansas City",
      "poi_type": "Education",
      "poi_address": "5000 Holmes St, Kansas City, MO 64110, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-486f-70fc-a01e-17c92c5cb817.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-486f-70fc-a01e-17c92c5cb817",
        "storage_key": "property/6767906449167479/01a010e6-486f-70fc-a01e-17c92c5cb817.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.umkc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10660093312754521544&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-missouri-kansas-city",
      "poi_latitude": "39.0333035",
      "poi_longitude": "-94.577545",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 816-235-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bab2-705c-8379-e221159bbb84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bab2-705c-8379-e221159bbb84",
        "storage_key": "property/6767906449167479/01a010e6-bab2-705c-8379-e221159bbb84.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ856Hn5DvwIcRyBVAa2NC8JM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_f720f25918c3988d326aa733",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "The Kansas City Public Library: Central Library",
      "poi_type": "Education",
      "poi_address": "14 W 10th St, Kansas City, MO 64105, USA",
      "poi_short_description": "false",
      "poi_long_description": "Visitors say this library offers a vast selection of books and media, including graphic novels, and features a beautiful building with stunning architecture and rotating art exhibits. They also highlight the helpful and friendly staff, as well as the convenient free parking validation and spotless restrooms. Others also like the dedicated children's area with activities and the free movies shown in the converted bank vault.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-4d32-71bc-9cba-26fab3959864.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-4d32-71bc-9cba-26fab3959864",
        "storage_key": "property/6767906449167479/01a010e6-4d32-71bc-9cba-26fab3959864.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.kclibrary.org/central",
      "poi_directions_map_url": "https://maps.google.com/?cid=649253124474496512&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-kansas-city-public-library-central-library",
      "poi_latitude": "39.1026894",
      "poi_longitude": "-94.5838852",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-701-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-babb-74a4-b8c0-dc649d766363.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-babb-74a4-b8c0-dc649d766363",
        "storage_key": "property/6767906449167479/01a010e6-babb-74a4-b8c0-dc649d766363.webp",
        "width": 192,
        "height": 174
      },
      "poi_google_place_id": "ChIJsZKiPV7wwIcRAGad3UacAgk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "ec_37772279c8d48cdfb9c9da0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Kansas City University",
      "poi_type": "Education",
      "poi_address": "1750 Independence Ave, Kansas City, MO 64106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-0868-76aa-911a-730054192ee5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-0868-76aa-911a-730054192ee5",
        "storage_key": "property/6767906449167479/01a010e6-0868-76aa-911a-730054192ee5.webp",
        "width": 1280,
        "height": 427
      },
      "poi_business_url": "http://kansascity.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16389816158537025495&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kansas-city-university",
      "poi_latitude": "39.1072822",
      "poi_longitude": "-94.5609759",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-654-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bab2-705c-8379-e221159bbb84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bab2-705c-8379-e221159bbb84",
        "storage_key": "property/6767906449167479/01a010e6-bab2-705c-8379-e221159bbb84.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg1greoD6wIcR14eOj_VSdOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_c323440eb88a4b06486ea299",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Rockhurst University",
      "poi_type": "Education",
      "poi_address": "1100 Rockhurst Rd, Kansas City, MO 64110, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-0665-73cb-90ea-f828062de2b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-0665-73cb-90ea-f828062de2b6",
        "storage_key": "property/6767906449167479/01a010e6-0665-73cb-90ea-f828062de2b6.webp",
        "width": 960,
        "height": 320
      },
      "poi_business_url": "https://www.rockhurst.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16644960823377639958&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rockhurst-university",
      "poi_latitude": "39.0303478",
      "poi_longitude": "-94.5710674",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 816-501-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bab2-705c-8379-e221159bbb84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bab2-705c-8379-e221159bbb84",
        "storage_key": "property/6767906449167479/01a010e6-bab2-705c-8379-e221159bbb84.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU6rD5oTvwIcRFrq3Ga7H_uY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_40f80047fd7d9f9d4e02f330",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Metropolitan Community College - Penn Valley",
      "poi_type": "Education",
      "poi_address": "3201 SW Trafficway, Kansas City, MO 64111, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-0428-732d-bcc8-83224f5ab093.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-0428-732d-bcc8-83224f5ab093",
        "storage_key": "property/6767906449167479/01a010e6-0428-732d-bcc8-83224f5ab093.webp",
        "width": 1200,
        "height": 675
      },
      "poi_business_url": "https://mcckc.edu/pennvalley",
      "poi_directions_map_url": "https://maps.google.com/?cid=6300199691525297033&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "metropolitan-community-college---penn-valley",
      "poi_latitude": "39.069596",
      "poi_longitude": "-94.5934436",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-604-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bab2-705c-8379-e221159bbb84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bab2-705c-8379-e221159bbb84",
        "storage_key": "property/6767906449167479/01a010e6-bab2-705c-8379-e221159bbb84.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLVWnUiTwwIcRiRNkUz3Oblc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_e92a019ed36c6543d03e2682",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Arrowhead Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1 Arrowhead Dr, Kansas City, MO 64129, USA",
      "poi_short_description": "Open-air stadium that's home to pro football's Kansas City Chiefs, also hosting big-name music acts.",
      "poi_long_description": "Visitors say this stadium offers an electrifying atmosphere, with many highlighting the unmatched tailgating experience and the passionate, welcoming fans. They also mention the stadium is clean, well-maintained, and features comfortable seating with great views from every section. Guests appreciate the friendly and helpful staff, efficient entry processes, and the wide variety of food and beverage options available.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-8d4b-7509-b35f-7e91dfb43902.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-8d4b-7509-b35f-7e91dfb43902",
        "storage_key": "property/6767906449167479/01a010e6-8d4b-7509-b35f-7e91dfb43902.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chiefs.com/stadium/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13604615317193311462&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arrowhead-stadium",
      "poi_latitude": "39.0489647",
      "poi_longitude": "-94.4840141",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 816-920-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-baad-720d-9236-4ffd70d115a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-baad-720d-9236-4ffd70d115a6",
        "storage_key": "property/6767906449167479/01a010e6-baad-720d-9236-4ffd70d115a6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK5LblKHkwIcR5kQl94xNzbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "ec_7b328ece11aa64ef46544322",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Kauffman Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1 Royal Way, Kansas City, MO 64129, USA",
      "poi_short_description": "Pro-baseball complex including the Royals Hall of Fame & a themed kids' play/practice area.",
      "poi_long_description": "People say this stadium offers great views from every seat and features iconic fountains, a Hall of Fame, and various kid-friendly activities like mini-golf. Visitors also highlight the ample and easy-to-navigate parking, along with a wide variety of food and drink options, including value concessions. They also praise the staff for being consistently friendly, helpful, and accommodating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-25fe-7222-bcd5-38005d369a5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-25fe-7222-bcd5-38005d369a5b",
        "storage_key": "property/6767906449167479/01a010e6-25fe-7222-bcd5-38005d369a5b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mlb.com/royals/ballpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=16543369561678857872&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kauffman-stadium",
      "poi_latitude": "39.0514836",
      "poi_longitude": "-94.480493",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 816-921-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-baad-720d-9236-4ffd70d115a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-baad-720d-9236-4ffd70d115a6",
        "storage_key": "property/6767906449167479/01a010e6-baad-720d-9236-4ffd70d115a6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcaDcmaDkwIcRkMbgP_faleU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "ec_b34a4fe2fadde32eddd6333c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Union Station Kansas City",
      "poi_type": "Entertainment",
      "poi_address": "30 W Pershing Rd, Kansas City, MO 64108, USA",
      "poi_short_description": "Grand, historic train station with permanent & temporary exhibits, a planetarium & a science center.",
      "poi_long_description": "Visitors say this historic train station features stunning architecture, a wide variety of engaging exhibits like Science City and the Titanic experience, and numerous dining options. They also highlight the helpful and friendly staff, especially during events and for assistance. Guests appreciate the clean, well-maintained environment and the convenient parking options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-25d2-73dd-b926-e5899d9c48fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-25d2-73dd-b926-e5899d9c48fa",
        "storage_key": "property/6767906449167479/01a010e6-25d2-73dd-b926-e5899d9c48fa.webp",
        "width": 850,
        "height": 1280
      },
      "poi_business_url": "http://www.unionstation.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1677210711716644829&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "union-station-kansas-city",
      "poi_latitude": "39.0846332",
      "poi_longitude": "-94.5850238",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-460-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bac9-761f-bc84-6f2aa2263185.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bac9-761f-bc84-6f2aa2263185",
        "storage_key": "property/6767906449167479/01a010e6-bac9-761f-bc84-6f2aa2263185.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxbu2nD_wwIcR3cdZjUGmRhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "ec_6f1bb0ec10b4d94794081a2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "The Nelson-Atkins Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "4525 Oak St, Kansas City, MO 64111, USA",
      "poi_short_description": "Art collection spanning 5,000 years in neoclassical & modern galleries, plus a sculpture garden.",
      "poi_long_description": "Visitors say this art museum features an impressive and diverse collection of art from various cultures and time periods, including famous masterpieces and ancient artifacts. They also highlight the free general admission, making it an accessible and valuable experience. Guests mention the beautiful building, well-maintained grounds, and friendly, knowledgeable staff who enhance the visit.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-5720-711e-9ce4-a057be1b18d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-5720-711e-9ce4-a057be1b18d1",
        "storage_key": "property/6767906449167479/01a010e6-5720-711e-9ce4-a057be1b18d1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nelson-atkins.org/?utm_source=gmb&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3122843275976164549&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-nelson-atkins-museum-of-art",
      "poi_latitude": "39.0449506",
      "poi_longitude": "-94.5809284",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-751-1278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bacd-758f-a8f1-b0b6745762c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bacd-758f-a8f1-b0b6745762c7",
        "storage_key": "property/6767906449167479/01a010e6-bacd-758f-a8f1-b0b6745762c7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJRSCf3ervwIcRxcTG-WmRVis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_8c3128400e044ad6dc827dae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "T-Mobile Center",
      "poi_type": "Entertainment",
      "poi_address": "1407 Grand Blvd, Kansas City, MO 64106, USA",
      "poi_short_description": "Indoor arena with nearly 20,000 seats hosts pro & college sporting events, big-name concerts & more.",
      "poi_long_description": "Visitors say this arena offers excellent sightlines and acoustics from all seats, with many highlighting the comfortable seating and clean, well-maintained facilities. They also appreciate the helpful and friendly staff, who ensure smooth entry and navigation. Guests mention the wide variety of food and beverage options, along with convenient self-serve stations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-550f-70bb-8e97-a3618eb29311.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-550f-70bb-8e97-a3618eb29311",
        "storage_key": "property/6767906449167479/01a010e6-550f-70bb-8e97-a3618eb29311.webp",
        "width": 1280,
        "height": 881
      },
      "poi_business_url": "http://www.t-mobilecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12445204140955467076&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "t-mobile-center",
      "poi_latitude": "39.0974667",
      "poi_longitude": "-94.5801529",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-949-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bae6-74c1-9063-c48b3774635a",
        "storage_key": "property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi31tv2fwwIcRRP3eijo_tqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "ec_821a47647ca60972f7653a13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Woodside",
      "poi_type": "Health and Wellness",
      "poi_address": "2000 W 47th Pl, Westwood, KS 66205, USA",
      "poi_short_description": "Group classes, pools and tennis make up this fitness club that also features a spa.",
      "poi_long_description": "People say this health club offers world-class facilities, including diverse fitness classes, high-end equipment, multiple pools, and a luxurious spa with cold plunges and saunas. They also highlight the welcoming community, attentive staff, and delicious food and beverage options.\n\nSome reviews mention the staff can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-4a35-771e-a043-9282781d3dc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-4a35-771e-a043-9282781d3dc6",
        "storage_key": "property/6767906449167479/01a010e6-4a35-771e-a043-9282781d3dc6.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "https://clubwoodside.com/?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=11500969705524282256&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodside",
      "poi_latitude": "39.0433789",
      "poi_longitude": "-94.6101981",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-831-0034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bae6-74c1-9063-c48b3774635a",
        "storage_key": "property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvYK1GjbuwIcRkMNNLgOnm58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_4c81680e33a18bee5c19f60e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1201 Emanuel Cleaver II Blvd., Kansas City, MO 64110, USA",
      "poi_short_description": "Friendly fitness center chain featuring cardio equipment and clean facilities.",
      "poi_long_description": "Reviewers consistently praise this gym for its great atmosphere and friendly staff. Patrons also appreciate the wide variety of cardio machines available.\n\nSome reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-5563-747a-b334-be5da3f4ad7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-5563-747a-b334-be5da3f4ad7e",
        "storage_key": "property/6767906449167479/01a010e6-5563-747a-b334-be5da3f4ad7e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/kansas-city-plaza-east-mo?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=13131085287844371648&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.0409021",
      "poi_longitude": "-94.5711806",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-237-7001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bae6-74c1-9063-c48b3774635a",
        "storage_key": "property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ10slq1LvwIcRwFxScX_8OrY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_e7eb531cba5000f720b976b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Pet Resource Center of Kansas City",
      "poi_type": "Health and Wellness",
      "poi_address": "1116 E 59th St, Kansas City, MO 64110, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-553e-70cf-8ed6-035bbb548590.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-553e-70cf-8ed6-035bbb548590",
        "storage_key": "property/6767906449167479/01a010e6-553e-70cf-8ed6-035bbb548590.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://prckc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10221368812531190358&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pet-resource-center-of-kansas-city",
      "poi_latitude": "39.0203563",
      "poi_longitude": "-94.5738127",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 816-353-0940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bae6-74c1-9063-c48b3774635a",
        "storage_key": "property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Y9HbXfvwIcRVootpceY2Y0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "ec_e18f3e1f39a933befe448850",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Kirk Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "222 W 11th St, Kansas City, MO 64105, USA",
      "poi_short_description": "Clean fitness space offering classes, pools and weight-machine areas.",
      "poi_long_description": "People say this gym offers a wide variety of modern equipment, including numerous cardio machines, free weights, and resistance machines, and features a clean facility with a pool and sauna. They also highlight the friendly and helpful staff, as well as the convenient and secure parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-8e26-74ca-981b-dcd4a7317788.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-8e26-74ca-981b-dcd4a7317788",
        "storage_key": "property/6767906449167479/01a010e6-8e26-74ca-981b-dcd4a7317788.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://kansascityymca.org/locations/downtownkc",
      "poi_directions_map_url": "https://maps.google.com/?cid=4676158556010780852&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kirk-family-ymca",
      "poi_latitude": "39.1011617",
      "poi_longitude": "-94.5865972",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-842-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bae6-74c1-9063-c48b3774635a",
        "storage_key": "property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdRvfnJLxwIcRtBhtbG4N5UA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_ca4a445f42ec0e68c6fa38ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Mission Veterinary Emergency & Specialty",
      "poi_type": "Health and Wellness",
      "poi_address": "5914 Johnson Dr, Mission, KS 66202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-5eb9-70ec-8c82-5f441cbb149a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-5eb9-70ec-8c82-5f441cbb149a",
        "storage_key": "property/6767906449167479/01a010e6-5eb9-70ec-8c82-5f441cbb149a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.missionveterinaryspecialists.com/?y_source=1_MTE2Njg5NDgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14428084234392665852&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mission-veterinary-emergency--specialty",
      "poi_latitude": "39.0225823",
      "poi_longitude": "-94.6543001",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-722-5566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bae6-74c1-9063-c48b3774635a",
        "storage_key": "property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO7kZjdLtwIcR_H5j_CraOsg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "ec_e481d39277bb80daeec40e8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Genesis Health Clubs - Power & Light",
      "poi_type": "Health and Wellness",
      "poi_address": "1261 Main St, Kansas City, MO 64105, USA",
      "poi_short_description": "Spacious, clean gym offering a range of classes, equipment and personal training.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, machines, and cardio options, with ample space for workouts. They also highlight the welcoming atmosphere and the knowledgeable, friendly staff who provide excellent guidance. Guests mention the facility is clean and well-maintained, with convenient parking and a great downtown location.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-7101-74ec-9403-11c4f32cf133.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-7101-74ec-9403-11c4f32cf133",
        "storage_key": "property/6767906449167479/01a010e6-7101-74ec-9403-11c4f32cf133.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/power-light.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=5275511582065765821&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "genesis-health-clubs---power--light",
      "poi_latitude": "39.0991682",
      "poi_longitude": "-94.5830873",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-268-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bae6-74c1-9063-c48b3774635a",
        "storage_key": "property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb2cpfF3wwIcRvS19QdVhNkk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_7888871150cb0c306468cd2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Chiefs Fit",
      "poi_type": "Health and Wellness",
      "poi_address": "612 W 47th St, Kansas City, MO 64112, USA",
      "poi_short_description": "Membership-only gym in the Country Club Plaza featuring a sauna, classes, and motivating instructors.",
      "poi_long_description": "Gym goers say this gym has a wide variety of top-notch equipment, a clean facility, and friendly staff. They also highlight the exceptional recovery room, especially the cryotherapy, and the helpful trainers who promote injury prevention and healthy habits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-8ccc-734e-b6b2-dd9fff7a50dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-8ccc-734e-b6b2-dd9fff7a50dc",
        "storage_key": "property/6767906449167479/01a010e6-8ccc-734e-b6b2-dd9fff7a50dc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://chiefsfit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12712496314265125622&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chiefs-fit",
      "poi_latitude": "39.0426076",
      "poi_longitude": "-94.594501",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-914-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bae6-74c1-9063-c48b3774635a",
        "storage_key": "property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCbLwysnvwIcR9kI8TAvca7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_35289bf2a2d7fdfd2d887c98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "The Glam Room KC",
      "poi_type": "Health and Wellness",
      "poi_address": "304 W 8th St, Kansas City, MO 64105, USA",
      "poi_short_description": "Upscale salon offering haircuts, coloring, styling and keratin treatments, plus spa treatments.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-715c-7618-8f3f-c83f209eda06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-715c-7618-8f3f-c83f209eda06",
        "storage_key": "property/6767906449167479/01a010e6-715c-7618-8f3f-c83f209eda06.webp",
        "width": 972,
        "height": 1280
      },
      "poi_business_url": "https://theglamroomkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18058766316528338710&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-glam-room-kc",
      "poi_latitude": "39.1047359",
      "poi_longitude": "-94.586456",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-605-1949",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bae6-74c1-9063-c48b3774635a",
        "storage_key": "property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvzlr6fTwwIcRFgd2Ekmgnfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "ec_11e564655f3e8fdd829bb746",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Flex Fitness Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "1536 Burlington St, Kansas City, MO 64116, USA",
      "poi_short_description": "Family-owned, welcoming gym with a friendly vibe offering memberships and day passes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-85f0-75fd-b872-ad48b071d10b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-85f0-75fd-b872-ad48b071d10b",
        "storage_key": "property/6767906449167479/01a010e6-85f0-75fd-b872-ad48b071d10b.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "http://www.flexfitnessgymkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6288445884305280141&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "flex-fitness-gym",
      "poi_latitude": "39.1376838",
      "poi_longitude": "-94.5808563",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-256-2249",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bae6-74c1-9063-c48b3774635a",
        "storage_key": "property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVX5Y0hr3wIcRjYxI0zYMRVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_f95fad7c4889f05d38b3265e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Cleaver Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "7000 Troost Ave, Kansas City, MO 64131, USA",
      "poi_short_description": "Community-focused fitness center, gym, and activity-packed family facility with a pool, yoga and swim classes and other activities.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment, including free weights, cardio machines, and resistance machines, as well as a pool and classes. They also highlight the friendly, welcoming, and helpful staff. Others mention the facility is clean, not too busy, and offers an affordable price.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-8fb7-761f-be2b-dc09fd548865.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-8fb7-761f-be2b-dc09fd548865",
        "storage_key": "property/6767906449167479/01a010e6-8fb7-761f-be2b-dc09fd548865.webp",
        "width": 1280,
        "height": 427
      },
      "poi_business_url": "https://kansascityymca.org/locations/cleaver",
      "poi_directions_map_url": "https://maps.google.com/?cid=17748384910504236803&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cleaver-family-ymca",
      "poi_latitude": "39.0002249",
      "poi_longitude": "-94.5769646",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 816-285-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bae6-74c1-9063-c48b3774635a",
        "storage_key": "property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZQK890LvwIcRAxeChwruTvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_049345486d55464f57a29082",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Children's Mercy Adele Hall Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "2401 Gillham Rd, Kansas City, MO 64108, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-97b5-77f4-9039-eabc9162af87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-97b5-77f4-9039-eabc9162af87",
        "storage_key": "property/6767906449167479/01a010e6-97b5-77f4-9039-eabc9162af87.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.childrensmercy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=241680805565643787&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "childrens-mercy-adele-hall-campus",
      "poi_latitude": "39.08387889999999",
      "poi_longitude": "-94.5771759",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-234-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-baa5-73a9-b5ba-6a9d36db7583.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-baa5-73a9-b5ba-6a9d36db7583",
        "storage_key": "property/6767906449167479/01a010e6-baa5-73a9-b5ba-6a9d36db7583.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9zZsZRPwwIcRCzzFhGmfWgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_63b692445c4375c5c838a7de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "KU Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3901 Rainbow Blvd, Kansas City, KS 66160, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-961f-73ef-ac2c-d273231eb8e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-961f-73ef-ac2c-d273231eb8e2",
        "storage_key": "property/6767906449167479/01a010e6-961f-73ef-ac2c-d273231eb8e2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.kumc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9948285583475587924&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ku-medical-center",
      "poi_latitude": "39.0582747",
      "poi_longitude": "-94.6105991",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-588-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-baa5-73a9-b5ba-6a9d36db7583.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-baa5-73a9-b5ba-6a9d36db7583",
        "storage_key": "property/6767906449167479/01a010e6-baa5-73a9-b5ba-6a9d36db7583.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJdbsoKb3vwIcRVLszpwdpD4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_07a92e9bf753fa3fcc4159f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Loose Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5200 Wornall Rd, Kansas City, MO 64112, USA",
      "poi_short_description": "Site of a Civil War battle, this 75-acre green space features a pond, tennis courts & a rose garden.",
      "poi_long_description": "People say this park features beautiful scenery, including a rose garden, a pond with fish and ducks, and well-maintained walking trails. Visitors also highlight the spacious open areas, perfect for picnics, relaxation, and various outdoor activities. They also appreciate the clean restrooms and family-friendly amenities like a splash pad and playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-977d-757e-ade2-b3168a3233c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-977d-757e-ade2-b3168a3233c9",
        "storage_key": "property/6767906449167479/01a010e6-977d-757e-ade2-b3168a3233c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kcparks.org/park/loose-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11009609457171665569&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loose-park",
      "poi_latitude": "39.0313445",
      "poi_longitude": "-94.5944237",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bebe-710f-87e3-8289b7d388f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bebe-710f-87e3-8289b7d388f8",
        "storage_key": "property/6767906449167479/01a010e6-bebe-710f-87e3-8289b7d388f8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUf-8Na_vwIcRoZJ_Snj9yZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_35467ddee73b667650009d6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Penn Valley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "West 29th Street, Broadway Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "Park with the National WWI Museum & Memorial, a theater & tennis, baseball & skateboarding venues.",
      "poi_long_description": "Visitors say this park offers beautiful views of the city skyline and is a great place for walking, taking pictures, and enjoying various activities like skateboarding. They also highlight the well-kept grounds and the tranquil atmosphere, making it a perfect spot for relaxation. Others mention it's an excellent open-air venue for events and a family-friendly destination.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-a452-776f-b129-120f84abb966.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-a452-776f-b129-120f84abb966",
        "storage_key": "property/6767906449167479/01a010e6-a452-776f-b129-120f84abb966.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kcparks.org/places/penn-valley-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15561286278733833014&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "penn-valley-park",
      "poi_latitude": "39.0757432",
      "poi_longitude": "-94.588766",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bebe-710f-87e3-8289b7d388f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bebe-710f-87e3-8289b7d388f8",
        "storage_key": "property/6767906449167479/01a010e6-bebe-710f-87e3-8289b7d388f8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYcMmnDvwwIcRNiMXXGzL9Nc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_10e45cb2a1b23b9d5c2d4ad8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Kaw Point Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1403 Fairfax Trafficway, Kansas City, KS 66115, USA",
      "poi_short_description": "Park with skyline views as well as water activities, theater events & Lewis & Clark heritage trail.",
      "poi_long_description": "Visitors say this park offers stunning views of the Kansas City skyline and the confluence of the Kansas and Missouri Rivers, along with historical information about the Lewis and Clark expedition. They also highlight the paved walking trails, fishing access, and ample parking.\n\nSome reviews mention there can be an unpleasant smell.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-9c9e-7589-aa09-a0a8c386e860.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-9c9e-7589-aa09-a0a8c386e860",
        "storage_key": "property/6767906449167479/01a010e6-9c9e-7589-aa09-a0a8c386e860.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kawpointpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1360269482962527033&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kaw-point-park",
      "poi_latitude": "39.1165937",
      "poi_longitude": "-94.6105429",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bebe-710f-87e3-8289b7d388f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bebe-710f-87e3-8289b7d388f8",
        "storage_key": "property/6767906449167479/01a010e6-bebe-710f-87e3-8289b7d388f8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJV4tf2xrxwIcROSPJQuOl4BI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_f80a6e19e744bb5a9091d2b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Berkley Riverfront",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "950 Riverfront Dr, Kansas City, MO 64120, USA",
      "poi_short_description": "Downtown green space along the Missouri River features broad biking & walking paths & open fields.",
      "poi_long_description": "People say this riverfront park offers open green spaces, a paved walking and biking trail, and sand volleyball courts. They also highlight the stunning views of the river and city skyline, and appreciate the clean, well-kept grounds. Others also say it's a peaceful and relaxing spot, perfect for a stroll or enjoying community events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-9b8f-729c-9e61-fdd71ca1b8b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-9b8f-729c-9e61-fdd71ca1b8b8",
        "storage_key": "property/6767906449167479/01a010e6-9b8f-729c-9e61-fdd71ca1b8b8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://berkleyriverfront.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3315902073752463479&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "berkley-riverfront",
      "poi_latitude": "39.1168217",
      "poi_longitude": "-94.5726106",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-559-3750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bebe-710f-87e3-8289b7d388f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bebe-710f-87e3-8289b7d388f8",
        "storage_key": "property/6767906449167479/01a010e6-bebe-710f-87e3-8289b7d388f8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJV2yvAJDwwIcRdyj_H15zBC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_197a83c6a4f0fafd0a626c4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "William E. Macken Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1002 Clark Ferguson Dr, North Kansas City, MO 64116, USA",
      "poi_short_description": "A 60-acre public park offering tennis, basketball, soccer & baseball facilities, plus playgrounds.",
      "poi_long_description": "People say this park is beautiful and spacious, offering well-maintained walking trails, multiple playgrounds, and sports fields. Visitors also highlight the clean restrooms, ample parking, and EV charging stations. They also like the quiet atmosphere, making it ideal for outdoor activities and family gatherings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-a3a8-75eb-9036-963cc8b9ab6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-a3a8-75eb-9036-963cc8b9ab6f",
        "storage_key": "property/6767906449167479/01a010e6-a3a8-75eb-9036-963cc8b9ab6f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.nkc.org/Home/Components/FacilityDirectory/FacilityDirectory/7/224",
      "poi_directions_map_url": "https://maps.google.com/?cid=17961710028332318408&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "william-e-macken-park",
      "poi_latitude": "39.1490619",
      "poi_longitude": "-94.5682706",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-300-0545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bebe-710f-87e3-8289b7d388f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bebe-710f-87e3-8289b7d388f8",
        "storage_key": "property/6767906449167479/01a010e6-bebe-710f-87e3-8289b7d388f8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJTwHNc1P3wIcRyL5RBRvQRPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_4959644b385e3ecb53421df4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Kansas City Airport - Wheeler Field",
      "poi_type": "Transportation & Transit",
      "poi_address": "900 Richards Rd, Kansas City, MO 64116, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-9c4a-70ce-b08b-faa10761d3c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-9c4a-70ce-b08b-faa10761d3c7",
        "storage_key": "property/6767906449167479/01a010e6-9c4a-70ce-b08b-faa10761d3c7.webp",
        "width": 1280,
        "height": 509
      },
      "poi_business_url": "http://www.flymkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6917393415046749860&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kansas-city-airport---wheeler-field",
      "poi_latitude": "39.1199859",
      "poi_longitude": "-94.5943256",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-859-7601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bede-76b9-9093-3c194515bf52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bede-76b9-9093-3c194515bf52",
        "storage_key": "property/6767906449167479/01a010e6-bede-76b9-9093-3c194515bf52.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJybRbhejwwIcRpN58O6mE_18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_2e8d329ebd4382b5c6aff3f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Kansas City",
      "poi_type": "Transportation & Transit",
      "poi_address": "30 W Pershing Rd Union Station, Kansas City, MO 64108, USA",
      "poi_short_description": "false",
      "poi_long_description": "Visitors say this train station features stunning architecture, a wide array of dining options, and engaging exhibits including a model train wing. They also highlight the clean restrooms and the friendly, helpful staff.\n\nSome reviews mention the walk to the train can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-a929-726b-b0eb-2d1a9014f292.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-a929-726b-b0eb-2d1a9014f292",
        "storage_key": "property/6767906449167479/01a010e6-a929-726b-b0eb-2d1a9014f292.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=KCY",
      "poi_directions_map_url": "https://maps.google.com/?cid=3787247529242741214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kansas-city",
      "poi_latitude": "39.0847966",
      "poi_longitude": "-94.5853578",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bee4-7390-ab98-d892ab2849af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bee4-7390-ab98-d892ab2849af",
        "storage_key": "property/6767906449167479/01a010e6-bee4-7390-ab98-d892ab2849af.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJxbu2nD_wwIcR3kn96I8BjzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_e2cd842603961a0213ee6bd0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Kansas City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Kansas City City Hall, 414 E 12th St, Kansas City, MO 64106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-a2ea-7214-98e4-1795ed2eaae5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-a2ea-7214-98e4-1795ed2eaae5",
        "storage_key": "property/6767906449167479/01a010e6-a2ea-7214-98e4-1795ed2eaae5.webp",
        "width": 781,
        "height": 1280
      },
      "poi_business_url": "http://www.kcmo.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16264843786418924934&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kansas-city-hall",
      "poi_latitude": "39.1008473",
      "poi_longitude": "-94.5780724",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-513-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bf00-729c-b49c-c915232075f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bf00-729c-b49c-c915232075f0",
        "storage_key": "property/6767906449167479/01a010e6-bf00-729c-b49c-c915232075f0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_e-zp2bwwIcRhi24uD9VuOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "ec_d8c9ad8dd223b797f3705dc0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Hallmark Corporate",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2501 McGee St, Kansas City, MO 64108, USA",
      "poi_short_description": "Retail chain specializing in greeting cards, gift wrap, ornaments & gifts for all occasions.",
      "poi_long_description": "Retail chain specializing in greeting cards, gift wrap, ornaments & gifts for all occasions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-aaaa-7073-b720-813b98384d99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-aaaa-7073-b720-813b98384d99",
        "storage_key": "property/6767906449167479/01a010e6-aaaa-7073-b720-813b98384d99.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://corporate.hallmark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1199437302719612463&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hallmark-corporate",
      "poi_latitude": "39.0811114",
      "poi_longitude": "-94.5800029",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 800-425-5627",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bae6-74c1-9063-c48b3774635a",
        "storage_key": "property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjzp5phbwwIcRL4b0Nt9BpRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_8469a2646d03f439f3128152",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "One Kansas City Place",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1200 Main St, Kansas City, MO 64105, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-a8b9-76fb-a0f8-e403780337b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-a8b9-76fb-a0f8-e403780337b4",
        "storage_key": "property/6767906449167479/01a010e6-a8b9-76fb-a0f8-e403780337b4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3149406623585977414&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "one-kansas-city-place",
      "poi_latitude": "39.0997374",
      "poi_longitude": "-94.5833889",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bae6-74c1-9063-c48b3774635a",
        "storage_key": "property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXfG48l3wwIcRRsQaTKPwtCs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_ae828f8ead6331790c8e7f62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Russell Stover Chocolates Corporate",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4900 Oak St, Kansas City, MO 64112, USA",
      "poi_short_description": "Retailer of chocolates, candies & gift baskets. Many also sell espresso, ice cream & baked goods.",
      "poi_long_description": "Retailer of chocolates, candies & gift baskets. Many also sell espresso, ice cream & baked goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-af17-7657-a181-82034c6086b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-af17-7657-a181-82034c6086b8",
        "storage_key": "property/6767906449167479/01a010e6-af17-7657-a181-82034c6086b8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.russellstover.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17106146491824718824&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "russell-stover-chocolates-corporate",
      "poi_latitude": "39.0382985",
      "poi_longitude": "-94.5832248",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-777-4004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bae6-74c1-9063-c48b3774635a",
        "storage_key": "property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeS-NZPCFw4cR6MMBIZo9Ze0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_de37f9ae2f9cedf78e730aa2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "google_places",
      "poi_name": "Full Employment Council",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1740 The Paseo #1740, Kansas City, MO 64108, USA",
      "poi_short_description": "Employment center likely focused on resources and training.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-b521-700f-991d-86ffbe9ce0b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a010e6-b521-700f-991d-86ffbe9ce0b3",
        "storage_key": "property/6767906449167479/01a010e6-b521-700f-991d-86ffbe9ce0b3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.feckc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11818534010114938229&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "full-employment-council",
      "poi_latitude": "39.09153",
      "poi_longitude": "-94.5652876",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-471-2330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a010e6-bae6-74c1-9063-c48b3774635a",
        "storage_key": "property/6767906449167479/01a010e6-bae6-74c1-9063-c48b3774635a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI7nwY3bwwIcRdRXGnhDeA6Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_f544b2db8d7aedb67d0862e6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "12:00"
    },
    {
      "id": "ec_e88fdb7ae2a4215ca1180d2f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "day": "MON",
      "open_time": "13:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_5ce420f73233cf947075346e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "12:00"
    },
    {
      "id": "ec_fa4ac51bc6bc2eb7712c3db1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "day": "TUE",
      "open_time": "13:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_0bfca6482464464db85fc4d8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "12:00"
    },
    {
      "id": "ec_0d5d5aa1c18dffab549e46c7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "day": "WED",
      "open_time": "13:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_45fb3d17ebc35078948c0532",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "12:00"
    },
    {
      "id": "ec_5d284f21f53dce67b794ea9a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "day": "THU",
      "open_time": "13:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_71857f405979f94a3ed26a20",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "12:00"
    },
    {
      "id": "ec_4540096649dc1c832e971c48",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "day": "FRI",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_7db1ca5c4dd76e84ecfdb03e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "rating": "5",
      "name": "Robin Daniels",
      "text": "I just recently moved into Piper Lofts but have had the easiest and best experience possible! The property manager, April, is just amazing. I go downstairs just to say hi and chat with her. She is always so friendly and has been since day one. She is there for whatever I need and is always so responsive even in the evenings when I have questions that may be silly. As a new resident and first time renter, it is so refreshing to always have a smiling face and someone who is always happy to see you. She is the absolute best and I hope she is at Piper Lofts for a long time 😊",
      "date": "2026-01-20",
      "title": "false"
    },
    {
      "id": "ec_4aaca63bae12d28f4ecd8270",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "rating": "5",
      "name": "Linda Henry",
      "text": "The Charcuterie and Wine party was great.  Everyone was having a great time meeting others in the building.  As always, April was a great hostess for this event.  Can’t wait to see what events are coming up. Thank you for events where tenants can come together.",
      "date": "2026-01-23",
      "title": "false"
    },
    {
      "id": "ec_5ac12588df01d9cc019a89ba",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "rating": "5",
      "name": "Luke",
      "text": "Such a wonderful apartment complex! I lived there under old management and when new management took over, and I gotta say the new management is stellar. I noticed how they improved everything and it really made me wish I could stay. They added a cute little dog park, a doggy washing station, Thursday drinks, better doors, instructions on how to get the leasing office, really awesome new blinds in all the apartments, I could go on. I can tell they really care, which I appreciate. Even in one instance where I sent some grumpy emails to April because of some miscommunication on things, April responded back kindly. I can tell they care about the tenants and want to take care of them. That alone is worth living here for. Sad to leave. If you can afford here, I’d say it’s a great place to live!",
      "date": "2025-09-03",
      "title": "false"
    },
    {
      "id": "ec_51efa0e53f6f22eedc733711",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "rating": "5",
      "name": "Tatiana Darby",
      "text": "I am coming up on my year since moving into to Piper and I don't think I can even express how grateful I am to have found this home! One of the hardest things about finding a place in KC that checked out all my boxes was finding a place that would accept my sweet 10 year old French Mastiff. Because of his size and breed most places don't give him a chance with their weight and breed restrictions. He is a gentle giant and has LOVED his home here at Piper. Whenever I take him for a walk he always pulls me right to the office because he knows his pal, Tiffany, will be there waiting for him with lots of treats! There are so many friends for him to play with here at Piper too. All the Piper dogs, and their humans of course, are truly the best! Anyone looking not only for a great new home for them but their beloved furry friends too, this is the place to be!! Mars will be eager to greet you when you come in!",
      "date": "2021-03-24",
      "title": "false"
    },
    {
      "id": "ec_cd87f916e4759cbd5cffabb7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "rating": "5",
      "name": "Brenna Winn",
      "text": "Best lofts in KC!!! Piper Lofts has been my favorite home in Kansas City. The units are very spacious with massive windows that offer great views of the city AND the amenities are 10/10. The building has private parking, a newly renovated gym, a small convenience store and a rooftop pool that overlooks downtown KC. It’s also in a perfect location in the Crossroads with bars and restaurants in walking distance in any direction!\n\nTiffany and the Piper team are also incredible to work with and have gone above and beyond for me. I’d highly recommend Piper Lofts over any residence in the KC downtown area!!",
      "date": "2024-02-13",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a01161-98c5-74ee-9362-aed7e3d79f06",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Piper Lofts Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-crossroads-kc",
      "search_query": "pet friendly apartments crossroads kansas city",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Crossroads KC",
      "h2_subtitle": "Discover pet-friendly living at Piper Lofts in Crossroads. Enjoy the vibrant neighborhood of Kansas City with your furry friends.",
      "page_copy": "Piper Lofts welcomes you and your pets to a vibrant lifestyle in the Crossroads neighborhood of Kansas City. Our pet-friendly apartments provide a perfect blend of comfort and style, featuring oversized windows allowing for natural light and stunning skyline views. Watch your pets enjoy the abundance of daylight as you appreciate the beautiful surroundings.\n\nLocated in the heart of Kansas City's bustling Crossroads district, Piper Lofts not only offers a pet-friendly environment but also places you within steps of city amenities. With a washer and dryer included in each unit and modern granite countertops, you'll find convenience at every turn. Enjoy peace of mind knowing you and your pets are in a community that embraces a comfortable, urban lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167479/01a010e6-878f-7201-9145-7ddf929ae6a6.webp",
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Crossroads KC",
      "seo_description": "Find pet-friendly apartments at Piper Lofts in Crossroads, KC. Enjoy vibrant living with your furry friend!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "page_item_url": "apartments-rooftop-pool-jackson-county",
      "search_query": "apartments with rooftop pool jackson county",
      "category": "Amenity",
      "h1_title": "Rooftop Pool Apartments in Jackson County",
      "h2_subtitle": "Experience luxury living with a rooftop pool at Piper Lofts. Situated in Jackson County, enjoy skyline views and premium amenities.",
      "page_copy": "Elevate your lifestyle at Piper Lofts, where luxury meets comfort in the heart of Jackson County. Our apartments offer access to a stunning rooftop area perfect for relaxing and enjoying spectacular skyline views. While we don't feature a pool on the rooftop, our location guarantees easy access to outdoor recreational activities and bustling city life.\n\nAt Piper Lofts, each unit is meticulously designed, featuring granite countertops and a convenient washer and dryer. The oversized windows provide breathtaking views of Kansas City's landmarks such as the Liberty Memorial and Union Station. Embrace the urban charm of the Crossroads neighborhood while enjoying the comforts of home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167479/01a010e6-878f-7201-9145-7ddf929ae6a6.webp",
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rooftop Pool Apartments in Jackson County",
      "seo_description": "Discover luxurious living at Piper Lofts with skyline views in Jackson County. Experience premium amenities without a rooftop pool.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "page_item_url": "luxury-apartments-in-unit-laundry-kc-mo",
      "search_query": "luxury apartments with in unit laundry kansas city mo",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with In-Unit Laundry KC MO",
      "h2_subtitle": "Piper Lofts offer luxury apartments with in-unit laundry. Enjoy modern amenities and skyline views in Kansas City, MO's Crossroads neighborhood.",
      "page_copy": "Immerse yourself in luxury living at Piper Lofts, located in the vibrant Crossroads district of Kansas City, MO. Our stylish apartments feature in-unit laundry facilities, allowing you the convenience of washing and drying from the comfort of your home. With granite countertops and oversized windows, each unit is designed with both luxury and functionality in mind.\n\nExperience breathtaking skyline views of iconic Kansas City landmarks including Liberty Memorial and Union Station right from your oversized windows. The Piper Lofts also boast a 24-hour micro market for those late-night snack cravings. It's urban living at its finest, blending luxury and convenience in the heart of Kansas City, MO.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167479/01a010e6-878f-7201-9145-7ddf929ae6a6.webp",
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with In-Unit Laundry KC MO",
      "seo_description": "Explore luxury living at Piper Lofts with in-unit laundry. Enjoy skyline views and modern amenities in Kansas City's Crossroads.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "page_item_url": "dog-park-apartments-near-kc-streetcar",
      "search_query": "apartments with dog park near kc street car",
      "category": "Amenity",
      "h1_title": "Apartments with Dog Park Near KC Streetcar",
      "h2_subtitle": "Discover pet-friendly living at Piper Lofts, near the KC Streetcar. Enjoy urban living with easy access to everything you and your pet need.",
      "page_copy": "Piper Lofts is where pet-friendly meets urban convenience, ideally located near the KC Streetcar line in Kansas City's vibrant Crossroads neighborhood. Although there isn't a dedicated dog park on-site, you'll find an abundance of pet-friendly amenities and nearby parks that cater to all your furry friend's needs.\n\nOur community allows you to enjoy the best of city living with easy access to local attractions and transportation. Revel in the comfort of modern living with amenities like in-unit laundry, granite countertops, and expansive windows offering breathtaking views. Piper Lofts is the perfect home for you and your pet, providing a cozy and connected Kansas City lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167479/01a010e6-878f-7201-9145-7ddf929ae6a6.webp",
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dog Park Near KC Streetcar",
      "seo_description": "Find pet-friendly apartments at Piper Lofts near KC Streetcar. Live in Crossroads, KC with convenient amenities and local attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "page_item_url": "parking-garage-apartments-64108",
      "search_query": "apartments with parking garage in 64108",
      "category": "Amenity",
      "h1_title": "Apartments with Parking Garage in 64108",
      "h2_subtitle": "Find convenience at Piper Lofts with parking garages in the heart of Kansas City, MO 64108. Enjoy the ease of urban living with modern amenities.",
      "page_copy": "Piper Lofts offers a prime location in the heart of Kansas City, MO's bustling 64108 neighborhood. Our apartments with parking garages provide residents with the ease and convenience of secure parking options right in the Crossroads district. This feature, along with our luxurious in-unit amenities, ensures a comfortable urban lifestyle.\n\nStep into your home adorned with elegant granite countertops and oversized windows framing stunning views of iconic Kansas City landmarks like the Liberty Memorial. With a 24-hour micro market available in the building, Piper Lofts delivers convenience and luxury. Experience the best of city living at Piper Lofts, designed for those who value both style and function.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167479/01a010e6-878f-7201-9145-7ddf929ae6a6.webp",
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Parking Garage in 64108",
      "seo_description": "Explore Piper Lofts in KC's 64108 with parking garages. Enjoy modern living in Crossroads with easy city access and comforts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-kansas-city-mo",
      "search_query": "one bedroom apartments kansas city mo",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Kansas City, MO",
      "h2_subtitle": "Explore the comfort of one-bedroom apartments at Piper Lofts. Located in Kansas City, MO, enjoy luxury living with stunning views and amenities.",
      "page_copy": "Discover a perfect blend of comfort and style at Piper Lofts, where our one-bedroom apartments cater to those seeking a chic urban lifestyle in Kansas City, MO. Each apartment is thoughtfully designed with oversized windows, offering breathtaking skyline views and allowing natural light to flood your living space. The modern interiors feature sleek granite countertops and in-unit laundry facilities, adding a touch of luxury and convenience.\n\nSituated in the lively Crossroads neighborhood, Piper Lofts grants easy access to a vibrant arts scene and local dining experiences. The building offers a 24-hour micro market, ensuring essentials are always within reach. Enjoy the dynamic energy of city life while relishing the tranquility of your own luxurious retreat at Piper Lofts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167479/01a010e6-878f-7201-9145-7ddf929ae6a6.webp",
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Kansas City, MO",
      "seo_description": "Discover one-bedroom apartments at Piper Lofts in Kansas City, MO. Enjoy urban living with skyline views and modern amenities in the Crossroads.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-crossroads-kc",
      "search_query": "two bedroom apartments crossroads kansas city",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Crossroads, KC",
      "h2_subtitle": "Experience spacious two-bedroom living at Piper Lofts in Crossroads, Kansas City. Enjoy modern amenities and vibrant neighborhood living.",
      "page_copy": "Piper Lofts offers expansive two-bedroom apartments in the heart of Crossroads, Kansas City. Designed for comfort and style, each unit features open layouts with oversized windows framing picturesque views of the city’s skyline. With granite countertops and the convenience of in-unit washers and dryers, our apartments deliver a combination of luxury and practicality.\n\nLocated in the dynamic Crossroads Arts District, residents at Piper Lofts have easy access to local galleries, boutiques, and dining establishments. The vibrant community offers a blend of urban excitement and homey comfort, perfectly suited to those seeking a lively cultural experience. Additionally, enjoy the convenience of our 24-hour micro market and the scenic surroundings unique to this neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167479/01a010e6-878f-7201-9145-7ddf929ae6a6.webp",
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Crossroads, KC",
      "seo_description": "Find spacious two-bedroom apartments at Piper Lofts in Crossroads, KC. Modern amenities and lively neighborhood offer urban convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-jackson-county-mo",
      "search_query": "three bedroom apartments jackson county mo",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Jackson County, MO",
      "h2_subtitle": "Discover spacious three-bedroom designs at Piper Lofts. Located in Jackson County, MO, enjoy modern amenities and stunning views of Kansas City.",
      "page_copy": "For those seeking generous living spaces, Piper Lofts presents upscale three-bedroom apartments located in Jackson County, MO. These residences boast expansive layouts perfect for families or those in need of extra room. Our apartments feature modern design elements, including granite countertops and oversized windows, which highlight the beautiful vistas of Kansas City's iconic landmarks.\n\nSituated in the vibrant Crossroads neighborhood, living at Piper Lofts allows residents to enjoy the artful energy and cultural offerings that define this area. With amenities like a 24-hour micro market, parking garage, and in-unit laundry, you'll experience a seamless blend of convenience and luxury. Embrace the opportunity to call one of Jackson County’s finest residences home at Piper Lofts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167479/01a010e6-878f-7201-9145-7ddf929ae6a6.webp",
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Jackson County, MO",
      "seo_description": "Explore three-bedroom apartments at Piper Lofts in Jackson County, MO. Enjoy spacious living with modern amenities and stunning Kansas City views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-missouri-kansas-city",
      "search_query": "apartments near university of missouri-kansas city",
      "category": "School",
      "h1_title": "Apartments Near University of Missouri-Kansas City",
      "h2_subtitle": "Find the perfect apartment at Piper Lofts, just a short distance from the University of Missouri-Kansas City. Enjoy stylish living and convenient amenities.",
      "page_copy": "Piper Lofts offers a range of stylish apartments that are conveniently located near the University of Missouri-Kansas City. Situated in the lively Crossroads District, our community provides easy access to the university while allowing you to experience the urban charm and artistic energy of Kansas City. Whether you're a student, faculty member, or university staff, our location keeps you connected to campus life without compromising on comfort.\n\nEach apartment is thoughtfully designed with modern amenities such as granite countertops and in-unit washers and dryers. Oversized windows provide sweeping views of the Kansas City skyline, including nearby landmarks. Plus, our on-site 24-hour micro market ensures you have access to essentials whenever you need them. Experience the best of both worlds when you choose Piper Lofts as your home near UMKC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167479/01a010e6-878f-7201-9145-7ddf929ae6a6.webp",
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Missouri-Kansas City",
      "seo_description": "Discover apartments at Piper Lofts near UMKC. Enjoy urban living with stylish amenities and easy access to the University.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "page_item_url": "living-near-kansas-city-university-mo",
      "search_query": "living near kansas city university mo",
      "category": "School",
      "h1_title": "Living Near Kansas City University, MO",
      "h2_subtitle": "Experience vibrant living near Kansas City University, MO, at Piper Lofts. Enjoy urban amenities and convenient access to education and city life.",
      "page_copy": "Piper Lofts, located in the heart of the Crossroads District, offers an ideal setting for those considering living near Kansas City University, MO. Our properties provide an excellent blend of comfortable and stylish living, with features like granite countertops, in-unit washers and dryers, and stunning cityscape views from oversized windows.\n\nBeing part of the Piper Lofts community means having quick access to Kansas City University, making it a perfect choice for students and professionals alike. The energetic atmosphere of the Crossroads neighborhood provides a unique blend of cultural experiences, dining, and shopping, ensuring you have a fulfilling city life. Plus, the convenience of a 24-hour micro market on-site means that the essentials are always within reach. Choose Piper Lofts for a seamless mix of academic proximity and urban excitement.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167479/01a010e6-878f-7201-9145-7ddf929ae6a6.webp",
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Kansas City University, MO",
      "seo_description": "Explore living close to Kansas City University at Piper Lofts. Enjoy urban amenities and quick access to the university and cultural experiences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "page_item_url": "rockhurst-university-apartments-crossroads",
      "search_query": "rockhurst university apartments crossroads",
      "category": "School",
      "h1_title": "Rockhurst University Apartments in Crossroads",
      "h2_subtitle": "Explore Piper Lofts, the ideal choice for Rockhurst University apartments in the Crossroads district. Enjoy modern living with unparalleled amenities.",
      "page_copy": "Situated in the vibrant Crossroads district, Piper Lofts offers an optimal living solution for those studying or working at Rockhurst University. Our community features well-designed apartments that cater to a variety of lifestyles, with modern amenities such as granite countertops and in-unit laundry facilities. Oversized windows offer natural light and breathtaking views of Kansas City's famous skyline, enhancing your living experience.\n\nLiving at Piper Lofts means being part of a dynamic neighborhood, known for its artistic flair and lively cultural scene. Just a short distance from Rockhurst University, our location ensures you stay connected to academic life while enjoying everything the Crossroads district has to offer. From convenient access to local eateries and shops to our on-site 24-hour micro market, Piper Lofts delivers the perfect balance of comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167479/01a010e6-878f-7201-9145-7ddf929ae6a6.webp",
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rockhurst University Apartments in Crossroads",
      "seo_description": "Discover Rockhurst University apartments at Piper Lofts in Crossroads. Enjoy modern amenities and convenient access to university life and city attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "page_item_url": "housing-by-metropolitan-community-college-penn-valley",
      "search_query": "housing by metropolitan community college penn valley",
      "category": "School",
      "h1_title": "Housing by Metropolitan Community College, Penn Valley",
      "h2_subtitle": "Find ideal housing near Metropolitan Community College, Penn Valley, at Piper Lofts. Enjoy city living with comfort and convenience.",
      "page_copy": "Piper Lofts provides excellent housing options near the Metropolitan Community College, Penn Valley campus. Nestled in the vibrant Crossroads district, our lofts offer modern living spaces equipped with premium features like granite countertops and in-unit washers and dryers. You'll also enjoy oversized windows that offer picturesque views of Kansas City's iconic landmarks, including Liberty Memorial and Union Station.\n\nBeing located close to Penn Valley means shorter commutes, giving you more time to focus on studies or relaxation. The Crossroads area around Piper Lofts is filled with diverse dining spots, galleries, and cultural destinations, offering a rich urban living experience. Our 24-hour micro market on the premises ensures you have access to daily necessities whenever needed. Choose Piper Lofts for stylish housing that combines educational convenience with the excitement of city life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167479/01a010e6-878f-7201-9145-7ddf929ae6a6.webp",
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing by Metropolitan Community College, Penn Valley",
      "seo_description": "Discover convenient housing near Penn Valley at Piper Lofts. Enjoy a modern living experience with easy access to education and city amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "page_item_url": "apartments-near-childrens-mercy-adele-hall-kansas-city",
      "search_query": "apartments near Children's Mercy Adele Hall Campus Kansas City",
      "category": "Hospital",
      "h1_title": "Apartments Near Children's Mercy, Adele Hall Campus",
      "h2_subtitle": "Discover Piper Lofts, the perfect choice for apartments near Children's Mercy Adele Hall Campus in Kansas City. Enjoy modern amenities and convenient access.",
      "page_copy": "Situated in the heart of Kansas City's vibrant Crossroads District, Piper Lofts offers an ideal living experience for those seeking apartments near Children's Mercy Adele Hall Campus. Our beautiful lofts come with modern comforts such as granite countertops and in-unit washers and dryers, designed to enhance your lifestyle. With oversized windows, you'll enjoy stunning views of key city landmarks such as Liberty Memorial and Union Station.\n\nLiving at Piper Lofts means you are just minutes away from Children's Mercy Adele Hall Campus, making it a convenient location for healthcare professionals and anyone connected with the hospital. Beyond the proximity to your workplace, the Crossroads area provides a lively cultural scene, with a variety of dining and entertainment options. Our 24-hour micro market ensures you have access to necessities around the clock. Choose Piper Lofts for a seamless blend of convenience and luxury.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167479/01a010e6-878f-7201-9145-7ddf929ae6a6.webp",
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Children's Mercy, Adele Hall",
      "seo_description": "Find convenient living with modern amenities at Piper Lofts, just minutes from Children's Mercy Adele Hall Campus in Kansas City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "page_item_url": "apartments-near-kaw-point-park-kansas-city",
      "search_query": "apartments near kaw point park kansas city",
      "category": "Park",
      "h1_title": "Apartments Near Kaw Point Park, Kansas City",
      "h2_subtitle": "Experience the serenity of Kaw Point Park by living at Piper Lofts, ideally situated in Kansas City's Crossroads District.",
      "page_copy": "Piper Lofts offers an exceptional apartment living experience just a short drive from Kaw Point Park, Kansas City. Our loft-style homes are designed with modern features like granite countertops and in-unit washers and dryers, providing both comfort and convenience. Large windows flood your space with natural light while offering panoramic views of downtown landmarks such as Liberty Memorial and Union Station.\n\nAround Piper Lofts, the vibrant Crossroads District awaits with a rich tapestry of cultural attractions, dining venues, and artistic hotspots. Enjoy being near the tranquility of Kaw Point Park, where you can indulge in outdoor activities or unwind in nature. Our community also offers a 24-hour micro market for your daily essentials, making life even easier. Choose Piper Lofts for an urban living experience close to nature and city dynamics.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167479/01a010e6-878f-7201-9145-7ddf929ae6a6.webp",
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kaw Point Park, KC",
      "seo_description": "Discover modern living at Piper Lofts, located near Kaw Point Park in Kansas City. Enjoy urban convenience and nature's tranquility close by.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "page_item_url": "piper-lofts-close-to-berkley-riverfront-moa",
      "search_query": "piper lofts close to berkley riverfront moa",
      "category": "Park",
      "h1_title": "Piper Lofts Close to Berkley Riverfront MOA",
      "h2_subtitle": "Enjoy the perfect blend of city life and riverside relaxation at Piper Lofts, conveniently located close to Berkley Riverfront MOA.",
      "page_copy": "Piper Lofts provides the ultimate urban living experience with its proximity to Berkley Riverfront MOA. Nestled in the bustling Crossroads District, our lofts feature sleek granite countertops, in-unit washers and dryers, and expansive windows that flood your home with light and offer spectacular views of Kansas City's skyline, including sights like Liberty Memorial and Union Station.\n\nWhether you're seeking relaxation by the riverfront or want to explore the vibrant city life just steps from your door, Piper Lofts offers it all. The nearby Berkley Riverfront is perfect for leisurely walks, exercise, or enjoying the scenic views of the Missouri River. Back at Piper Lofts, take advantage of the 24-hour micro market for all your late-night cravings. Embark on a sophisticated lifestyle that fuses nature with city perks at Piper Lofts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167479/01a010e6-878f-7201-9145-7ddf929ae6a6.webp",
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Piper Lofts Near Berkley Riverfront MOA",
      "seo_description": "Live near the scenic Berkley Riverfront MOA at Piper Lofts. Enjoy the best of urban living with modern amenities in Kansas City's Crossroads.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167479",
      "source": "generator",
      "page_item_url": "crossroads-living-by-macken-park-jackson-county",
      "search_query": "crossroads living by william e. macken park jackson county",
      "category": "Park",
      "h1_title": "Crossroads Living by Macken Park",
      "h2_subtitle": "Experience vibrant Crossroads living in Jackson County, near William E. Macken Park, at Piper Lofts. Dive into a lifestyle that blends comfort and convenience.",
      "page_copy": "At Piper Lofts, you can immerse yourself in the dynamic atmosphere of the Crossroads District, with the added advantage of being close to William E. Macken Park in Jackson County. Our contemporary lofts come equipped with premium amenities, including granite countertops for a sleek cooking space and in-unit washers and dryers for utmost convenience. Enjoy breathtaking skyline views from oversized windows framing Kansas City's skyline.\n\nLiving at Piper Lofts means you’re nestled in a neighborhood famed for its artistic flair, with easy access to Macken Park, a perfect escape for recreational activities. This ideal location combines urban excitement with a touch of tranquility from nature. For everyday needs, enjoy the convenience of our 24-hour micro market just steps from your door. Choose Crossroads living at Piper Lofts, where your modern lifestyle needs are met with flair.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167479/01a010e6-878f-7201-9145-7ddf929ae6a6.webp",
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Crossroads Living by Macken Park",
      "seo_description": "Discover Piper Lofts in the Crossroads, close to William E. Macken Park, Jackson County. Enjoy modern amenities and a vibrant lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": []
};

export const generatedAt = '2026-10-05T18:29:37.322Z';
